/**
 * @license
 * Copyright (c) Peculiar Ventures, LLC.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

export const OIDsShort = {
  '2.5.4.3': 'CN',
  '2.5.4.6': 'C',
  '0.9.2342.19200300.100.1.25': 'DC',
  '1.2.840.113549.1.9.1': 'E',
  '2.5.4.42': 'G',
  '2.5.4.43': 'I',
  '2.5.4.7': 'L',
  '2.5.4.10': 'O',
  '2.5.4.11': 'OU',
  '2.5.4.8': 'ST',
  '2.5.4.4': 'SN',
  '2.5.4.12': 'T',
  '2.5.4.15': 'businessCategory',
  '1.3.6.1.4.1.311.60.2.1.3': 'jurisdictionCountry',
  '2.5.4.5': 'serialNumber',
  '2.5.4.97': 'OI',
};

export const OIDs = {
  '0.2.262.1.10': 'Telesec',
  '0.2.262.1.10.0': 'Extension',
  '0.2.262.1.10.1': 'Mechanism',
  '0.2.262.1.10.1.0': 'Authentication',
  '0.2.262.1.10.1.0.1': 'Password Authentication',
  '0.2.262.1.10.1.0.2': 'Protected Password Authentication',
  '0.2.262.1.10.1.0.3': 'One Way x509 Authentication',
  '0.2.262.1.10.1.0.4': 'Two Way x509 Authentication',
  '0.2.262.1.10.1.0.5': 'Three Way x509 Authentication',
  '0.2.262.1.10.1.0.6': 'One Way IS O9798 Authentication',
  '0.2.262.1.10.1.0.7': 'Two Way IS O9798 Authentication',
  '0.2.262.1.10.1.0.8': 'Telekom Authentication',
  '0.2.262.1.10.1.1': 'Signature',
  '0.2.262.1.10.1.1.1': 'MD4 with RSA And IS O9697',
  '0.2.262.1.10.1.1.2': 'MD4 with RSA And Telesec Signature Standard',
  '0.2.262.1.10.1.1.3': 'MD5 with RSA And IS O9697',
  '0.2.262.1.10.1.1.4': 'MD5 with RSA And Telesec Signature Standard',
  '0.2.262.1.10.1.1.5': 'Ripemd160 with RSA And Telekom Signature Standard',
  '0.2.262.1.10.1.1.9': 'HBCI RSA Signature',
  '0.2.262.1.10.1.2': 'Encryption',
  '0.2.262.1.10.1.2.0': 'None',
  '0.2.262.1.10.1.2.1': 'RSA Telesec',
  '0.2.262.1.10.1.2.2': 'DES',
  '0.2.262.1.10.1.2.2.1': 'DES ECB',
  '0.2.262.1.10.1.2.2.2': 'DES CBC',
  '0.2.262.1.10.1.2.2.3': 'DES OFB',
  '0.2.262.1.10.1.2.2.4': 'DES CFB8',
  '0.2.262.1.10.1.2.2.5': 'DES CFB64',
  '0.2.262.1.10.1.2.3': 'DES3',
  '0.2.262.1.10.1.2.3.1': 'DES3 ECB',
  '0.2.262.1.10.1.2.3.2': 'DES3 CBC',
  '0.2.262.1.10.1.2.3.3': 'DES3 OFB',
  '0.2.262.1.10.1.2.3.4': 'DES3 CFB8',
  '0.2.262.1.10.1.2.3.5': 'DES3 CFB64',
  '0.2.262.1.10.1.2.4': 'Magenta',
  '0.2.262.1.10.1.2.5': 'Idea',
  '0.2.262.1.10.1.2.5.1': 'Idea ECB',
  '0.2.262.1.10.1.2.5.2': 'Idea CBC',
  '0.2.262.1.10.1.2.5.3': 'Idea OFB',
  '0.2.262.1.10.1.2.5.4': 'Idea CFB8',
  '0.2.262.1.10.1.2.5.5': 'Idea CFB64',
  '0.2.262.1.10.1.3': 'One Way Function',
  '0.2.262.1.10.1.3.1': 'MD4',
  '0.2.262.1.10.1.3.2': 'MD5',
  '0.2.262.1.10.1.3.3': 'SQ ModNx509',
  '0.2.262.1.10.1.3.4': 'SQ ModNISO',
  '0.2.262.1.10.1.3.5': 'Ripemd128',
  '0.2.262.1.10.1.3.6': 'Hash Using Block Cipher',
  '0.2.262.1.10.1.3.7': 'Mac',
  '0.2.262.1.10.1.3.8': 'Ripemd160',
  '0.2.262.1.10.1.4': 'Fec Function',
  '0.2.262.1.10.1.4.1': 'Reed Solomon',
  '0.2.262.1.10.2': 'Module',
  '0.2.262.1.10.2.0': 'Algorithms',
  '0.2.262.1.10.2.1': 'Attribute Types',
  '0.2.262.1.10.2.2': 'Certificate Types',
  '0.2.262.1.10.2.3': 'Message Types',
  '0.2.262.1.10.2.4': 'Pl Protocol',
  '0.2.262.1.10.2.5': 'Sme And Components Of Sme',
  '0.2.262.1.10.2.6': 'Fec',
  '0.2.262.1.10.2.7': 'Useful Definitions',
  '0.2.262.1.10.2.8': 'Stefiles',
  '0.2.262.1.10.2.9': 'Sadmib',
  '0.2.262.1.10.2.10': 'Electronic Order',
  '0.2.262.1.10.2.11': 'Telesec Ttp Asymmetric Application',
  '0.2.262.1.10.2.12': 'Telesec Ttp Basis Application',
  '0.2.262.1.10.2.13': 'Telesec Ttp Messages',
  '0.2.262.1.10.2.14': 'Telesec Ttp Time Stamp Application',
  '0.2.262.1.10.3': 'Object Class',
  '0.2.262.1.10.3.0': 'Telesec Other Name',
  '0.2.262.1.10.3.1': 'Directory',
  '0.2.262.1.10.3.2': 'Directory Type',
  '0.2.262.1.10.3.3': 'Directory Group',
  '0.2.262.1.10.3.4': 'Directory User',
  '0.2.262.1.10.3.5': 'Symmetric Key Entry',
  '0.2.262.1.10.4': 'Package',
  '0.2.262.1.10.5': 'Parameter',
  '0.2.262.1.10.6': 'Name Binding',
  '0.2.262.1.10.7': 'Attribute',
  '0.2.262.1.10.7.0': 'Application Group Identifier',
  '0.2.262.1.10.7.1': 'Certificate Type',
  '0.2.262.1.10.7.2': 'Telesec Certificate',
  '0.2.262.1.10.7.3': 'Certificate Number',
  '0.2.262.1.10.7.4': 'Certificate Revocation List',
  '0.2.262.1.10.7.5': 'Creation Date',
  '0.2.262.1.10.7.6': 'Issuer',
  '0.2.262.1.10.7.7': 'Naming Authority',
  '0.2.262.1.10.7.8': 'Public Key Directory',
  '0.2.262.1.10.7.9': 'Security Domain',
  '0.2.262.1.10.7.10': 'Subject',
  '0.2.262.1.10.7.11': 'Time Of Revocation',
  '0.2.262.1.10.7.12': 'User Group Reference',
  '0.2.262.1.10.7.13': 'alidity',
  '0.2.262.1.10.7.14': 'Zert93',
  '0.2.262.1.10.7.15': 'Security Mess Env',
  '0.2.262.1.10.7.16': 'Anonymized Public Key Directory',
  '0.2.262.1.10.7.17': 'Telesec Given Name',
  '0.2.262.1.10.7.18': 'Name Additions',
  '0.2.262.1.10.7.19': 'Telesec Postal Code',
  '0.2.262.1.10.7.20': 'Name Distinguisher',
  '0.2.262.1.10.7.21': 'Telesec Certificate List',
  '0.2.262.1.10.7.22': 'Teletrust Certificate List',
  '0.2.262.1.10.7.23': 'x509 Certificate List',
  '0.2.262.1.10.7.24': 'Time Of Issue',
  '0.2.262.1.10.7.25': 'Physical Card Number',
  '0.2.262.1.10.7.26': 'File Type',
  '0.2.262.1.10.7.27': 'Ctl File Is Archive',
  '0.2.262.1.10.7.28': 'Email Address',
  '0.2.262.1.10.7.29': 'Certificate Template List',
  '0.2.262.1.10.7.30': 'Directory Name',
  '0.2.262.1.10.7.31': 'Directory Type Name',
  '0.2.262.1.10.7.32': 'Directory Group Name',
  '0.2.262.1.10.7.33': 'Directory User Name',
  '0.2.262.1.10.7.34': 'Revocation Flag',
  '0.2.262.1.10.7.35': 'Symmetric Key Entry Name',
  '0.2.262.1.10.7.36': 'Gl Number',
  '0.2.262.1.10.7.37': 'Go Number',
  '0.2.262.1.10.7.38': 'G Key Data',
  '0.2.262.1.10.7.39': 'Z Key Data',
  '0.2.262.1.10.7.40': 'Kt Key Data',
  '0.2.262.1.10.7.41': 'Kt Key Number',
  '0.2.262.1.10.7.51': 'Time Of Revocation Gen',
  '0.2.262.1.10.7.52': 'Liability Text',
  '0.2.262.1.10.8': 'Attribute Group',
  '0.2.262.1.10.9': 'Action',
  '0.2.262.1.10.10': 'Notification',
  '0.2.262.1.10.11': 'Snmp-mibs',
  '0.2.262.1.10.11.1': 'Security Application',
  '0.2.262.1.10.12': 'Cert And Crl Extension Definitions',
  '0.2.262.1.10.12.0': 'Liability Limitation Flag',
  '0.2.262.1.10.12.1': 'Telesec Cert Id Ext',
  '0.2.262.1.10.12.2': 'Telesec policy Identifier',
  '0.2.262.1.10.12.3': 'Telesec Policy Qualifier I D',
  '0.2.262.1.10.12.4': 'Telesec CRL Filtered Ext',
  '0.2.262.1.10.12.5': 'Telesec CRL Filter Ext',
  '0.2.262.1.10.12.6': 'Telesec Naming Authority Ext',
  '0.4.0.127.0.7': 'Bsi',
  '0.4.0.127.0.7.1': 'Bsi Ecc',
  '0.4.0.127.0.7.1.1': 'Bsifield Type',
  '0.4.0.127.0.7.1.1.1': 'Bsi Prime Field',
  '0.4.0.127.0.7.1.1.2': 'Bsi Characteristic Two Field',
  '0.4.0.127.0.7.1.1.2.2': 'Bsi ECTLV Key Format',
  '0.4.0.127.0.7.1.1.2.2.1': 'Bsi ECTLV Public Key',
  '0.4.0.127.0.7.1.1.2.3': 'Bsi Characteristic Two Basis',
  '0.4.0.127.0.7.1.1.2.3.1': 'Bsi Gn Basis',
  '0.4.0.127.0.7.1.1.2.3.2': 'Bsi Tp Basis',
  '0.4.0.127.0.7.1.1.2.3.3': 'Bsi Pp Basis',
  '0.4.0.127.0.7.1.1.4.1': 'Bsi Ecdsa Signatures',
  '0.4.0.127.0.7.1.1.4.1.1': 'Bsi Ecdsa with SHA1',
  '0.4.0.127.0.7.1.1.4.1.2': 'Bsi Ecdsa with SHA224',
  '0.4.0.127.0.7.1.1.4.1.3': 'Bsi Ecdsa with SHA256',
  '0.4.0.127.0.7.1.1.4.1.4': 'Bsi Ecdsa with SHA384',
  '0.4.0.127.0.7.1.1.4.1.5': 'Bsi Ecdsa with SHA512',
  '0.4.0.127.0.7.1.1.4.1.6': 'Bsi Ecdsa with RIPEMD160',
  '0.4.0.127.0.7.1.1.5.1.1': 'Bsi Ecka Eg x963KDF',
  '0.4.0.127.0.7.1.1.5.1.1.1': 'Bsi Ecka Eg x963KDF with SHA1',
  '0.4.0.127.0.7.1.1.5.1.1.2': 'Bsi Ecka Eg x963KDF with SHA224',
  '0.4.0.127.0.7.1.1.5.1.1.3': 'Bsi Ecka Eg x963KDF with SHA256',
  '0.4.0.127.0.7.1.1.5.1.1.4': 'Bsi Ecka Eg x963KDF with SHA384',
  '0.4.0.127.0.7.1.1.5.1.1.5': 'Bsi Ecka Eg x963KDF with SHA512',
  '0.4.0.127.0.7.1.1.5.1.1.6': 'Bsi Ecka Eg x963KDF with RIPEMD160',
  '0.4.0.127.0.7.1.1.5.1.2': 'Bsi Ecka Eg Session KDF',
  '0.4.0.127.0.7.1.1.5.1.2.1': 'Bsi Ecka Eg Session KDF With3DES',
  '0.4.0.127.0.7.1.1.5.1.2.2': 'Bsi Ecka Eg Session KDF with AES128',
  '0.4.0.127.0.7.1.1.5.1.2.3': 'Bsi Ecka Eg Session KDF with AES192',
  '0.4.0.127.0.7.1.1.5.1.2.4': 'Bsi Ecka Eg Session KDF with AES256',
  '0.4.0.127.0.7.1.1.5.2': 'Bsi Ecka DH',
  '0.4.0.127.0.7.1.1.5.2.1': 'Bsi Ecka DH x963KDF',
  '0.4.0.127.0.7.1.1.5.2.1.1': 'Bsi Ecka DHx963KDF with SHA1',
  '0.4.0.127.0.7.1.1.5.2.1.2': 'Bsi Ecka DHx963KDF with SHA224',
  '0.4.0.127.0.7.1.1.5.2.1.3': 'Bsi Ecka DHx963KDF with SHA256',
  '0.4.0.127.0.7.1.1.5.2.1.4': 'Bsi Ecka DHx963KDF with SHA384',
  '0.4.0.127.0.7.1.1.5.2.1.5': 'Bsi Ecka DHx963KDF with SHA512',
  '0.4.0.127.0.7.1.1.5.2.1.6': 'Bsi Ecka DHx963KDF with RIPEMD160',
  '0.4.0.127.0.7.1.1.5.2.2': 'Bsi Ecka DHSessionKDF',
  '0.4.0.127.0.7.1.1.5.2.2.1': 'Bsi Ecka DH Session KDF With3 DES',
  '0.4.0.127.0.7.1.1.5.2.2.2': 'Bsi Ecka DH Session KDF with AES128',
  '0.4.0.127.0.7.1.1.5.2.2.3': 'Bsi Ecka DH Session KDF with AES192',
  '0.4.0.127.0.7.1.1.5.2.2.4': 'Bsi Ecka DH Session KDF with AES256',
  '0.4.0.127.0.7.1.2': 'Bsi Ec Key Type',
  '0.4.0.127.0.7.1.2.1': 'Bsi Ec Public Key',
  '0.4.0.127.0.7.1.5.1': 'Bsi Kaeg',
  '0.4.0.127.0.7.1.5.1.1': 'Bsi Kaeg with x963KDF',
  '0.4.0.127.0.7.1.5.1.2': 'Bsi Kaeg with 3DESKDF',
  '0.4.0.127.0.7.2.2.1': 'Bsi PK',
  '0.4.0.127.0.7.2.2.1.1': 'Bsi PK_DH',
  '0.4.0.127.0.7.2.2.1.2': 'Bsi PK_ECDH',
  '0.4.0.127.0.7.2.2.2': 'Bsi TA',
  '0.4.0.127.0.7.2.2.2.1': 'Bsi TA_RSA',
  '0.4.0.127.0.7.2.2.2.1.1': 'Bsi TA_RSAv1_5_SHA1',
  '0.4.0.127.0.7.2.2.2.1.2': 'Bsi TA_RSAv1_5_SHA256',
  '0.4.0.127.0.7.2.2.2.1.3': 'Bsi TA_RSAPSS_SHA1',
  '0.4.0.127.0.7.2.2.2.1.4': 'Bsi TA_RSAPSS_SHA256',
  '0.4.0.127.0.7.2.2.2.1.5': 'Bsi TA_RSAv1_5_SHA512',
  '0.4.0.127.0.7.2.2.2.1.6': 'Bsi TA_RSAPSS_SHA512',
  '0.4.0.127.0.7.2.2.2.2': 'Bsi TA_ECDSA',
  '0.4.0.127.0.7.2.2.2.2.1': 'Bsi TA_ECDSA_SHA1',
  '0.4.0.127.0.7.2.2.2.2.2': 'Bsi TA_ECDSA_SHA224',
  '0.4.0.127.0.7.2.2.2.2.3': 'Bsi TA_ECDSA_SHA256',
  '0.4.0.127.0.7.2.2.2.2.4': 'Bsi TA_ECDSA_SHA384',
  '0.4.0.127.0.7.2.2.2.2.5': 'Bsi TA_ECDSA_SHA512',
  '0.4.0.127.0.7.2.2.3': 'Bsi CA',
  '0.4.0.127.0.7.2.2.3.1': 'Bsi CA_DH',
  '0.4.0.127.0.7.2.2.3.1.1': 'Bsi CA_DH_3DES_CBC_CBC',
  '0.4.0.127.0.7.2.2.3.1.2': 'Bsi CA_DH_AES_CBC_CMAC_128',
  '0.4.0.127.0.7.2.2.3.1.3': 'Bsi CA_DH_AES_CBC_CMAC_192',
  '0.4.0.127.0.7.2.2.3.1.4': 'Bsi CA_DH_AES_CBC_CMAC_256',
  '0.4.0.127.0.7.2.2.3.2': 'Bsi CA_ECDH',
  '0.4.0.127.0.7.2.2.3.2.1': 'Bsi CA_ECDH_3DES_CBC_CBC',
  '0.4.0.127.0.7.2.2.3.2.2': 'Bsi CA_ECDH_AES_CBC_CMAC_128',
  '0.4.0.127.0.7.2.2.3.2.3': 'Bsi CA_ECDH_AES_CBC_CMAC_192',
  '0.4.0.127.0.7.2.2.3.2.4': 'Bsi CA_ECDH_AES_CBC_CMAC_256',
  '0.4.0.127.0.7.2.2.4': 'Bsi PACE',
  '0.4.0.127.0.7.2.2.4.1': 'Bsi PACE_DH_GM',
  '0.4.0.127.0.7.2.2.4.1.1': 'Bsi PACE_DH_GM_3DES_CBC_CBC',
  '0.4.0.127.0.7.2.2.4.1.2': 'Bsi PACE_DH_GM_AES_CBC_CMAC_128',
  '0.4.0.127.0.7.2.2.4.1.3': 'Bsi PACE_DH_GM_AES_CBC_CMAC_192',
  '0.4.0.127.0.7.2.2.4.1.4': 'Bsi PACE_DH_GM_AES_CBC_CMAC_256',
  '0.4.0.127.0.7.2.2.4.2': 'Bsi PACE_ECDH_GM',
  '0.4.0.127.0.7.2.2.4.2.1': 'Bsi PACE_ECDH_GM_3DES_CBC_CBC',
  '0.4.0.127.0.7.2.2.4.2.2': 'Bsi PACE_ECDH_GM_AES_CBC_CMAC_128',
  '0.4.0.127.0.7.2.2.4.2.3': 'Bsi PACE_ECDH_GM_AES_CBC_CMAC_192',
  '0.4.0.127.0.7.2.2.4.2.4': 'Bsi PACE_ECDH_GM_AES_CBC_CMAC_256',
  '0.4.0.127.0.7.2.2.4.3': 'Bsi PACE_DH_IM',
  '0.4.0.127.0.7.2.2.4.3.1': 'Bsi PACE_DH_IM_3DES_CBC_CBC',
  '0.4.0.127.0.7.2.2.4.3.2': 'Bsi PACE_DH_IM_AES_CBC_CMAC_128',
  '0.4.0.127.0.7.2.2.4.3.3': 'Bsi PACE_DH_IM_AES_CBC_CMAC_192',
  '0.4.0.127.0.7.2.2.4.3.4': 'Bsi PACE_DH_IM_AES_CBC_CMAC_256',
  '0.4.0.127.0.7.2.2.4.4': 'Bsi PACE_ECDH_IM',
  '0.4.0.127.0.7.2.2.4.4.1': 'Bsi PACE_ECDH_IM_3DES_CBC_CBC',
  '0.4.0.127.0.7.2.2.4.4.2': 'Bsi PACE_ECDH_IM_AES_CBC_CMAC_128',
  '0.4.0.127.0.7.2.2.4.4.3': 'Bsi PACE_ECDH_IM_AES_CBC_CMAC_192',
  '0.4.0.127.0.7.2.2.4.4.4': 'Bsi PACE_ECDH_IM_AES_CBC_CMAC_256',
  '0.4.0.127.0.7.2.2.5': 'Bsi RI',
  '0.4.0.127.0.7.2.2.5.1': 'Bsi RI_DH',
  '0.4.0.127.0.7.2.2.5.1.1': 'Bsi RI_DH_SHA1',
  '0.4.0.127.0.7.2.2.5.1.2': 'Bsi RI_DH_SHA224',
  '0.4.0.127.0.7.2.2.5.1.3': 'Bsi RI_DH_SHA256',
  '0.4.0.127.0.7.2.2.5.1.4': 'Bsi RI_DH_SHA384',
  '0.4.0.127.0.7.2.2.5.1.5': 'Bsi RI_DH_SHA512',
  '0.4.0.127.0.7.2.2.5.2': 'Bsi RI_ECDH',
  '0.4.0.127.0.7.2.2.5.2.1': 'Bsi RI_ECDH_SHA1',
  '0.4.0.127.0.7.2.2.5.2.2': 'Bsi RI_ECDH_SHA224',
  '0.4.0.127.0.7.2.2.5.2.3': 'Bsi RI_ECDH_SHA256',
  '0.4.0.127.0.7.2.2.5.2.4': 'Bsi RI_ECDH_SHA384',
  '0.4.0.127.0.7.2.2.5.2.5': 'Bsi RI_ECDH_SHA512',
  '0.4.0.127.0.7.2.2.6': 'Bsi Card Info',
  '0.4.0.127.0.7.2.2.7': 'Bsi Eid Security',
  '0.4.0.127.0.7.2.2.8': 'Bsi PT',
  '0.4.0.127.0.7.3.1.2': 'Bsi EAC Roles',
  '0.4.0.127.0.7.3.1.2.1': 'Bsi EAC Roles IS',
  '0.4.0.127.0.7.3.1.2.2': 'Bsi EAC Roles AT',
  '0.4.0.127.0.7.3.1.2.3': 'Bsi EAC Roles ST',
  '0.4.0.127.0.7.3.1.3': 'Bsi TAv2ce',
  '0.4.0.127.0.7.3.1.3.1': 'Bsi TAv2ce Description',
  '0.4.0.127.0.7.3.1.3.1.1': 'Bsi TAv2ce Description Plain Text',
  '0.4.0.127.0.7.3.1.3.1.2': 'Bsi TAv2ce Description IA5 String',
  '0.4.0.127.0.7.3.1.3.1.3': 'Bsi TAv2ce Description Octet String',
  '0.4.0.127.0.7.3.1.3.2': 'Bsi TAv2ce Terminal Sector',
  '0.4.0.127.0.7.3.1.4': 'Bsi Aux Data',
  '0.4.0.127.0.7.3.1.4.1': 'Bsi Aux Data Birthday',
  '0.4.0.127.0.7.3.1.4.2': 'Bsi Aux Data Expire Date',
  '0.4.0.127.0.7.3.1.4.3': 'Bsi Aux Data Community ID',
  '0.4.0.127.0.7.3.1.5': 'Bsi Defect List',
  '0.4.0.127.0.7.3.1.5.1': 'Bsi Defect Auth Defect',
  '0.4.0.127.0.7.3.1.5.1.1': 'Bsi Defect Cert Revoked',
  '0.4.0.127.0.7.3.1.5.1.2': 'Bsi Defect Cert Replaced',
  '0.4.0.127.0.7.3.1.5.1.3': 'Bsi Defect Chip Auth Key Revoked',
  '0.4.0.127.0.7.3.1.5.1.4': 'Bsi Defect Active Auth Key Revoked',
  '0.4.0.127.0.7.3.1.5.2': 'Bsi Defect EPassport Defect',
  '0.4.0.127.0.7.3.1.5.2.1': 'Bsi Defect EPassport DG Malformed',
  '0.4.0.127.0.7.3.1.5.2.2': 'Bsi Defect SOD Invalid',
  '0.4.0.127.0.7.3.1.5.3': 'Bsi Defect EID Defect',
  '0.4.0.127.0.7.3.1.5.3.1': 'Bsi Defect EIDDG Malformed',
  '0.4.0.127.0.7.3.1.5.3.2': 'Bsi Defect EID Integrity',
  '0.4.0.127.0.7.3.1.5.4': 'Bsi Defect Document Defect',
  '0.4.0.127.0.7.3.1.5.4.1': 'Bsi Defect Card Security Malformed',
  '0.4.0.127.0.7.3.1.5.4.2': 'Bsi Defect Chip Security Malformed',
  '0.4.0.127.0.7.3.1.5.4.3': 'Bsi Defect Power Down Req',
  '0.4.0.127.0.7.3.1.6': 'Bsi List Content Description',
  '0.4.0.127.0.7.3.2.1': 'Bsi Security Object',
  '0.4.0.127.0.7.3.2.2': 'Bsi Black List',
  '0.4.0.1862': 'ETSI QCS Profile',
  '0.4.0.1862.1': 'ETSI QCS',
  '0.4.0.1862.1.1': 'ETSI QCS Compliance',
  '0.4.0.1862.1.2': 'ETSI QCS Limit Value',
  '0.4.0.1862.1.3': 'ETSI QCS Retention Period',
  '0.4.0.1862.1.4': 'ETSI QCS SSCD',
  '0.4.0.1862.1.5': 'ETSI QCS PDS',
  '0.4.0.1862.1.6': 'ETSI QC Type',
  '0.4.0.1862.1.6.1': 'ETSI QC Type eSign',
  '0.4.0.1862.1.6.2': 'ETSI QC Type eSeal',
  '0.4.0.1862.1.6.3': 'ETSI QC Type Web',
  '0.4.0.194121.1.2': 'ETSI QCS Semantics ID Legal',
  '0.4.0.194112.1.0': 'QCP Natural Person',
  '0.4.0.194112.1.1': 'QCP Legal Person',
  '0.4.0.194112.1.2': 'QCP Natural QSCD',
  '0.4.0.194112.1.3': 'QCP Legal QSCD',
  '0.4.0.194112.1.4': 'QCP Web',
  '0.9.2342.19200300.100.1.1': 'User ID',
  '0.9.2342.19200300.100.1.3': 'Rfc822 Mailbox',
  '0.9.2342.19200300.100.1.25': 'Domain Component',
  '1.0.10118.3.0.49': 'Ripemd160',
  '1.0.10118.3.0.50': 'Ripemd128',
  '1.0.10118.3.0.55': 'Whirlpool',
  '1.2.36.1.3.1.1.1': 'Qgpki',
  '1.2.36.1.3.1.1.1.1': 'Qgpki Policies',
  '1.2.36.1.3.1.1.1.1.1': 'Qgpki Med Intermed CA',
  '1.2.36.1.3.1.1.1.1.1.1': 'Qgpki Med Intermed Individual',
  '1.2.36.1.3.1.1.1.1.1.2': 'Qgpki Med Intermed Device Control',
  '1.2.36.1.3.1.1.1.1.1.3': 'Qgpki Med Intermed Device',
  '1.2.36.1.3.1.1.1.1.1.4': 'Qgpki Med Intermed Authorised Party',
  '1.2.36.1.3.1.1.1.1.1.5': 'Qgpki Med Intermed Device System',
  '1.2.36.1.3.1.1.1.1.2': 'Qgpki Med Issuing CA',
  '1.2.36.1.3.1.1.1.1.2.1': 'Qgpki Med Issuing Individual',
  '1.2.36.1.3.1.1.1.1.2.2': 'Qgpki Med Issuing Device Control',
  '1.2.36.1.3.1.1.1.1.2.3': 'Qgpki Med Issuing Device',
  '1.2.36.1.3.1.1.1.1.2.4': 'Qgpki Med Issuing Authorised Party',
  '1.2.36.1.3.1.1.1.1.2.5': 'Qgpki Med Issuing Client Auth',
  '1.2.36.1.3.1.1.1.1.2.6': 'Qgpki Med Issuing Server Auth',
  '1.2.36.1.3.1.1.1.1.2.7': 'Qgpki Med Issuing Data Prot',
  '1.2.36.1.3.1.1.1.1.2.8': 'Qgpki Med Issuing Token Auth',
  '1.2.36.1.3.1.1.1.1.3': 'Qgpki Basic Intermed CA',
  '1.2.36.1.3.1.1.1.1.3.1': 'Qgpki Basic Intermed Device System',
  '1.2.36.1.3.1.1.1.1.4': 'Qgpki Basic Issuing CA',
  '1.2.36.1.3.1.1.1.1.4.1': 'Qgpki Basic Issuing Client Auth',
  '1.2.36.1.3.1.1.1.1.4.2': 'Qgpki Basic Issuing Server Auth',
  '1.2.36.1.3.1.1.1.1.4.3': 'Qgpki Basic Issuing Data Signing',
  '1.2.36.1.3.1.1.1.2': 'Qgpki Assurance Level',
  '1.2.36.1.3.1.1.1.2.1': 'Qgpki Assurance Rudimentary',
  '1.2.36.1.3.1.1.1.2.2': 'Qgpki Assurance Basic',
  '1.2.36.1.3.1.1.1.2.3': 'Qgpki Assurance Medium',
  '1.2.36.1.3.1.1.1.2.4': 'Qgpki Assurance High',
  '1.2.36.1.3.1.1.1.3': 'Qgpki Cert Function',
  '1.2.36.1.3.1.1.1.3.1': 'Qgpki Function Individual',
  '1.2.36.1.3.1.1.1.3.2': 'Qgpki Function Device',
  '1.2.36.1.3.1.1.1.3.3': 'Qgpki Function Authorised Party',
  '1.2.36.1.3.1.1.1.3.4': 'Qgpki Function Device Control',
  '1.2.36.1.3.1.2': 'Qpspki',
  '1.2.36.1.3.1.2.1': 'Qpspki Policies',
  '1.2.36.1.3.1.2.1.2': 'Qpspki Policy Basic',
  '1.2.36.1.3.1.2.1.3': 'Qpspki Policy Medium',
  '1.2.36.1.3.1.2.1.4': 'Qpspki Policy High',
  '1.2.36.1.3.1.3.2': 'Qtmrpki',
  '1.2.36.1.3.1.3.2.1': 'Qtmrpki Policies',
  '1.2.36.1.3.1.3.2.2': 'Qtmrpki Purpose',
  '1.2.36.1.3.1.3.2.2.1': 'Qtmrpki Individual',
  '1.2.36.1.3.1.3.2.2.2': 'Qtmrpki Device Control',
  '1.2.36.1.3.1.3.2.2.3': 'Qtmrpki Device',
  '1.2.36.1.3.1.3.2.2.4': 'Qtmrpki Authorised Party',
  '1.2.36.1.3.1.3.2.2.5': 'Qtmrpki Device System',
  '1.2.36.1.3.1.3.2.3': 'Qtmrpki Device',
  '1.2.36.1.3.1.3.2.3.1': 'Qtmrpki Driver License',
  '1.2.36.1.3.1.3.2.3.2': 'Qtmrpki Industry Authority',
  '1.2.36.1.3.1.3.2.3.3': 'Qtmrpki Marine License',
  '1.2.36.1.3.1.3.2.3.4': 'Qtmrpki Adult Proof Of Age',
  '1.2.36.1.3.1.3.2.3.5': 'Qtmrpki Sam',
  '1.2.36.1.3.1.3.2.4': 'Qtmrpki Authorised Party',
  '1.2.36.1.3.1.3.2.4.1': 'Qtmrpki Transport Inspector',
  '1.2.36.1.3.1.3.2.4.2': 'Qtmrpki Police Officer',
  '1.2.36.1.3.1.3.2.4.3': 'Qtmrpki System',
  '1.2.36.1.3.1.3.2.4.4': 'Qtmrpki Liquor Licensing Inspector',
  '1.2.36.1.3.1.3.2.4.5': 'Qtmrpki Marine Enforcement Officer',
  '1.2.36.1.333.1': 'Australian Business Number',
  '1.2.36.68980861.1.1.2': 'Signet Personal',
  '1.2.36.68980861.1.1.3': 'Signet Business',
  '1.2.36.68980861.1.1.4': 'Signet Legal',
  '1.2.36.68980861.1.1.10': 'Signet Pilot',
  '1.2.36.68980861.1.1.11': 'Signet Intra Net',
  '1.2.36.68980861.1.1.20': 'Signet Policy',
  '1.2.36.75878867.1.100.1.1': 'Certificates Australia Policy',
  '1.2.40.0.17.1.22': 'A-Trust EV policy',
  '1.2.392.200011.61.1.1.1': 'Mitsubishi Security Algorithm',
  '1.2.392.200011.61.1.1.1.1': 'Misty1-cbc',
  '1.2.392.200091.100.721.1': 'Security Communication (SECOM) EV policy',
  '1.2.410.200004.1': 'Kisa Algorithm',
  '1.2.410.200004.1.1': 'Kcdsa',
  '1.2.410.200004.1.2': 'Has160',
  '1.2.410.200004.1.3': 'Seed ECB',
  '1.2.410.200004.1.4': 'Seed CBC',
  '1.2.410.200004.1.5': 'Seed OFB',
  '1.2.410.200004.1.6': 'Seed CFB',
  '1.2.410.200004.1.7': 'Seed MAC',
  '1.2.410.200004.1.8': 'Kcdsa with HAS160',
  '1.2.410.200004.1.9': 'Kcdsa with SHA1',
  '1.2.410.200004.1.10': 'PBE with HAS160 And SEED-ECB',
  '1.2.410.200004.1.11': 'PBE with HAS160 And SEED-CBC',
  '1.2.410.200004.1.12': 'PBE with HAS160 And SEED-CFB',
  '1.2.410.200004.1.13': 'PBE with HAS160 And SEED-OFB',
  '1.2.410.200004.1.14': 'PBE with SHA1 And SEED-ECB',
  '1.2.410.200004.1.15': 'PBE with SHA1 And SEED-CBC',
  '1.2.410.200004.1.16': 'PBE with SHA1 And SEED-CFB',
  '1.2.410.200004.1.17': 'PBE with SHA1 And SEED-OFB',
  '1.2.410.200004.1.20': 'RSA with HAS160',
  '1.2.410.200004.1.21': 'Kcdsa1',
  '1.2.410.200004.2': 'Npki CP',
  '1.2.410.200004.2.1': 'Npki Signature Policy',
  '1.2.410.200004.3': 'Npki KP',
  '1.2.410.200004.4': 'Npki AT',
  '1.2.410.200004.5': 'Npki LCA',
  '1.2.410.200004.5.1': 'Npki Sign Korea',
  '1.2.410.200004.5.2': 'Npki Sign Gate',
  '1.2.410.200004.5.3': 'Npki Nca Sign',
  '1.2.410.200004.6': 'Npki ON',
  '1.2.410.200004.7': 'Npki APP',
  '1.2.410.200004.7.1': 'Npki SMIME',
  '1.2.410.200004.7.1.1': 'Npki SMIME Algo',
  '1.2.410.200004.7.1.1.1': 'Npki Cms SEED Wrap',
  '1.2.410.200004.10': 'Npki',
  '1.2.410.200004.10.1': 'Npki Attribute',
  '1.2.410.200004.10.1.1': 'Npki Identify Data',
  '1.2.410.200004.10.1.1.1': 'Npki VID',
  '1.2.410.200004.10.1.1.2': 'Npki Encrypted VID',
  '1.2.410.200004.10.1.1.3': 'Npki Random Num',
  '1.2.410.200004.10.1.1.4': 'Npki VID',
  '1.2.410.200046.1.1': 'Aria1 Algorithm Modes',
  '1.2.410.200046.1.1.1': 'Aria128-ecb',
  '1.2.410.200046.1.1.2': 'Aria128-cbc',
  '1.2.410.200046.1.1.3': 'Aria128-cfb',
  '1.2.410.200046.1.1.4': 'Aria128-ofb',
  '1.2.410.200046.1.1.5': 'Aria128-ctr',
  '1.2.410.200046.1.1.6': 'Aria192-ecb',
  '1.2.410.200046.1.1.7': 'Aria192-cbc',
  '1.2.410.200046.1.1.8': 'Aria192-cfb',
  '1.2.410.200046.1.1.9': 'Aria192-ofb',
  '1.2.410.200046.1.1.10': 'Aria192-ctr',
  '1.2.410.200046.1.1.11': 'Aria256-ecb',
  '1.2.410.200046.1.1.12': 'Aria256-cbc',
  '1.2.410.200046.1.1.13': 'Aria256-cfb',
  '1.2.410.200046.1.1.14': 'Aria256-ofb',
  '1.2.410.200046.1.1.15': 'Aria256-ctr',
  '1.2.410.200046.1.1.21': 'Aria128-cmac',
  '1.2.410.200046.1.1.22': 'Aria192-cmac',
  '1.2.410.200046.1.1.23': 'Aria256-cmac',
  '1.2.410.200046.1.1.31': 'Aria128-ocb2',
  '1.2.410.200046.1.1.32': 'Aria192-ocb2',
  '1.2.410.200046.1.1.33': 'Aria256-ocb2',
  '1.2.410.200046.1.1.34': 'Aria128-gcm',
  '1.2.410.200046.1.1.35': 'Aria192-gcm',
  '1.2.410.200046.1.1.36': 'Aria256-gcm',
  '1.2.410.200046.1.1.37': 'Aria128-ccm',
  '1.2.410.200046.1.1.38': 'Aria192-ccm',
  '1.2.410.200046.1.1.39': 'Aria256-ccm',
  '1.2.410.200046.1.1.40': 'Aria128-keywrap',
  '1.2.410.200046.1.1.41': 'Aria192-keywrap',
  '1.2.410.200046.1.1.42': 'Aria256-keywrap',
  '1.2.410.200046.1.1.43': 'Aria128-keywrap with Pad',
  '1.2.410.200046.1.1.44': 'Aria192-keywrap with Pad',
  '1.2.410.200046.1.1.45': 'Aria256-keywrap with Pad',
  '1.2.643.2.2.3': 'Gost Signature',
  '1.2.643.2.2.4': 'Gost94 Signature',
  '1.2.643.2.2.9': 'Gost Digest',
  '1.2.643.2.2.10': 'Hmac Gost',
  '1.2.643.2.2.13.0': 'Gost Wrap',
  '1.2.643.2.2.13.1': 'Crypto Pro Wrap',
  '1.2.643.2.2.14.0': 'Null Meshing',
  '1.2.643.2.2.14.1': 'Crypto Pro Meshing',
  '1.2.643.2.2.19': 'Gost Public Key',
  '1.2.643.2.2.20': 'Gost94 Public Key',
  '1.2.643.2.2.21': 'Gost Cipher',
  '1.2.643.2.2.30.0': 'Test Digest Params',
  '1.2.643.2.2.30.1': 'Crypto Pro Digest A',
  '1.2.643.2.2.31.0': 'Test Cipher Params',
  '1.2.643.2.2.31.1': 'Crypto Pro Cipher A',
  '1.2.643.2.2.31.2': 'Crypto Pro Cipher B',
  '1.2.643.2.2.31.3': 'Crypto Pro Cipher C',
  '1.2.643.2.2.31.4': 'Crypto Pro Cipher D',
  '1.2.643.2.2.31.5': 'Oscar11 Cipher',
  '1.2.643.2.2.31.6': 'Oscar10 Cipher',
  '1.2.643.2.2.31.7': 'Ric1 Cipher',
  '1.2.643.2.2.35.0': 'Test Sign Params',
  '1.2.643.2.2.35.1': 'Crypto Pro Sign A',
  '1.2.643.2.2.35.2': 'Crypto Pro Sign B',
  '1.2.643.2.2.35.3': 'Crypto Pro Sign C',
  '1.2.643.2.2.36.0': 'Crypto Pro Sign XA',
  '1.2.643.2.2.36.1': 'Crypto Pro Sign XB',
  '1.2.643.2.2.96': 'Crypto Pro ECDH Wrap',
  '1.2.752.34.1': 'Seis-cp',
  '1.2.752.34.1.1': 'SEIS high-assurance policy Identifier',
  '1.2.752.34.1.2': 'SEIS GAK policy Identifier',
  '1.2.752.34.2': 'SEI Spe',
  '1.2.752.34.3': 'SEI Sat',
  '1.2.752.34.3.1': 'SEI Sat-personal Identifier',
  '1.2.840.10040.1': 'Module',
  '1.2.840.10040.1.1': 'x9f1-cert-mgmt',
  '1.2.840.10040.2': 'Holdinstruction',
  '1.2.840.10040.2.1': 'Holdinstruction-none',
  '1.2.840.10040.2.2': 'Callissuer',
  '1.2.840.10040.2.3': 'Reject',
  '1.2.840.10040.2.4': 'Pickup Token',
  '1.2.840.10040.3': 'Attribute',
  '1.2.840.10040.3.1': 'Countersignature',
  '1.2.840.10040.3.2': 'Attribute-cert',
  '1.2.840.10040.4': 'Algorithm',
  '1.2.840.10040.4.1': 'DSA',
  '1.2.840.10040.4.2': 'DSA-match',
  '1.2.840.10040.4.3': 'DSA with SHA1',
  '1.2.840.10045.1': 'Field Type',
  '1.2.840.10045.1.1': 'Prime-field',
  '1.2.840.10045.1.2': 'Characteristic-two-field',
  '1.2.840.10045.1.2.3': 'Characteristic-two-basis',
  '1.2.840.10045.1.2.3.1': 'ON Basis',
  '1.2.840.10045.1.2.3.2': 'TP Basis',
  '1.2.840.10045.1.2.3.3': 'PP Basis',
  '1.2.840.10045.2': 'Public Key Type',
  '1.2.840.10045.2.1': 'EC Public Key',
  '1.2.840.10045.3.0.1': 'C2pnb163v1',
  '1.2.840.10045.3.0.2': 'C2pnb163v2',
  '1.2.840.10045.3.0.3': 'C2pnb163v3',
  '1.2.840.10045.3.0.5': 'C2tnb191v1',
  '1.2.840.10045.3.0.6': 'C2tnb191v2',
  '1.2.840.10045.3.0.7': 'C2tnb191v3',
  '1.2.840.10045.3.0.10': 'C2pnb208w1',
  '1.2.840.10045.3.0.11': 'C2tnb239v1',
  '1.2.840.10045.3.0.12': 'C2tnb239v2',
  '1.2.840.10045.3.0.13': 'C2tnb239v3',
  '1.2.840.10045.3.0.16': 'C2pnb272w1',
  '1.2.840.10045.3.0.18': 'C2tnb359v1',
  '1.2.840.10045.3.0.19': 'C2pnb368w1',
  '1.2.840.10045.3.0.20': 'C2tnb431r1',
  '1.2.840.10045.3.1.1': 'Prime192v1',
  '1.2.840.10045.3.1.2': 'Prime192v2',
  '1.2.840.10045.3.1.3': 'Prime192v3',
  '1.2.840.10045.3.1.4': 'Prime239v1',
  '1.2.840.10045.3.1.5': 'Prime239v2',
  '1.2.840.10045.3.1.6': 'Prime239v3',
  '1.2.840.10045.3.1.7': 'Prime256v1',
  '1.2.840.10045.4.1': 'ECDSA with SHA1',
  '1.2.840.10045.4.2': 'ECDSA with Recommended',
  '1.2.840.10045.4.3': 'ECDSA with Specified',
  '1.2.840.10045.4.3.1': 'ECDSA with SHA224',
  '1.2.840.10045.4.3.2': 'ECDSA with SHA256',
  '1.2.840.10045.4.3.3': 'ECDSA with SHA384',
  '1.2.840.10045.4.3.4': 'ECDSA with SHA512',
  '1.2.840.10046.1': 'Field Type',
  '1.2.840.10046.1.1': 'Gf-prime',
  '1.2.840.10046.2': 'Number Type',
  '1.2.840.10046.2.1': 'DH Public Key',
  '1.2.840.10046.3': 'Scheme',
  '1.2.840.10046.3.1': 'DH Static',
  '1.2.840.10046.3.2': 'DH Ephem',
  '1.2.840.10046.3.3': 'DH Hybrid1',
  '1.2.840.10046.3.4': 'DH Hybrid2',
  '1.2.840.10046.3.5': 'Mqv2',
  '1.2.840.10046.3.6': 'Mqv1',
  '1.2.840.10065.2.2': '?',
  '1.2.840.10065.2.3': 'Healthcare License',
  '1.2.840.10065.2.3.1.1': 'License?',
  '1.2.840.10070.': 'Iec62351',
  '1.2.840.10070.8': 'Iec62351_8',
  '1.2.840.10070.8.1': 'Iec User Roles',
  '1.2.840.113533.7': 'NSN',
  '1.2.840.113533.7.65': 'NSN-ce',
  '1.2.840.113533.7.65.0': 'Entrust Version Info',
  '1.2.840.113533.7.66': 'NSN-alg',
  '1.2.840.113533.7.66.3': 'Cast3 CBC',
  '1.2.840.113533.7.66.10': 'Cast5 CBC',
  '1.2.840.113533.7.66.11': 'Cast5 MAC',
  '1.2.840.113533.7.66.12': 'PBE with MD5 And CAST5-CBC',
  '1.2.840.113533.7.66.13': 'Password Based Mac',
  '1.2.840.113533.7.67': 'NSN-oc',
  '1.2.840.113533.7.67.0': 'Entrust User',
  '1.2.840.113533.7.68': 'NSN-at',
  '1.2.840.113533.7.68.0': 'Entrust CA Info',
  '1.2.840.113533.7.68.10': 'Attribute Certificate',
  '1.2.840.113549.1.1': 'PKCS-1',
  '1.2.840.113549.1.1.1': 'RSA Encryption',
  '1.2.840.113549.1.1.2': 'MD2 with RSA Encryption',
  '1.2.840.113549.1.1.3': 'MD4 with RSA Encryption',
  '1.2.840.113549.1.1.4': 'MD5 with RSA Encryption',
  '1.2.840.113549.1.1.5': 'SHA1 with RSA Encryption',
  '1.2.840.113549.1.1.6': 'RSA OAEP Encryption SET',
  '1.2.840.113549.1.1.7': 'RSA OAEP',
  '1.2.840.113549.1.1.8': 'PKCS1-MGF',
  '1.2.840.113549.1.1.9': 'RSA OAEP-p Specified',
  '1.2.840.113549.1.1.10': 'RSA PSS',
  '1.2.840.113549.1.1.11': 'SHA256 with RSA Encryption',
  '1.2.840.113549.1.1.12': 'SHA384 with RSA Encryption',
  '1.2.840.113549.1.1.13': 'SHA512 with RSA Encryption',
  '1.2.840.113549.1.1.14': 'SHA224 with RSA Encryption',
  '1.2.840.113549.1.2': 'Bsafe Rsa Encr',
  '1.2.840.113549.1.3': 'PKCS-3',
  '1.2.840.113549.1.3.1': 'Dh Key Agreement',
  '1.2.840.113549.1.5': 'PKCS-5',
  '1.2.840.113549.1.5.1': 'PBE with MD2 And DES-CBC',
  '1.2.840.113549.1.5.3': 'PBE with MD5 And DES-CBC',
  '1.2.840.113549.1.5.4': 'PBE with MD2 And RC2-CBC',
  '1.2.840.113549.1.5.6': 'PBE with MD5 And RC2-CBC',
  '1.2.840.113549.1.5.9': 'PBE with MD5 And XOR',
  '1.2.840.113549.1.5.10': 'PBE with SHA And DES-CBC',
  '1.2.840.113549.1.5.12': 'PKCS5 PBKDF2',
  '1.2.840.113549.1.5.13': 'PKCS5 PBES2',
  '1.2.840.113549.1.5.14': 'PKCS5 PBMAC1',
  '1.2.840.113549.1.7': 'PKCS-7',
  '1.2.840.113549.1.7.1': 'Data',
  '1.2.840.113549.1.7.2': 'Signed Data',
  '1.2.840.113549.1.7.3': 'Enveloped Data',
  '1.2.840.113549.1.7.4': 'Signed And Enveloped Data',
  '1.2.840.113549.1.7.5': 'Digested Data',
  '1.2.840.113549.1.7.6': 'Encrypted Data',
  '1.2.840.113549.1.7.7': 'Data with Attributes',
  '1.2.840.113549.1.7.8': 'Encrypted Private Key Info',
  '1.2.840.113549.1.9': 'PKCS-9',
  '1.2.840.113549.1.9.1': 'Email',
  '1.2.840.113549.1.9.2': 'Unstructured Name',
  '1.2.840.113549.1.9.3': 'Content Type',
  '1.2.840.113549.1.9.4': 'Message Digest',
  '1.2.840.113549.1.9.5': 'Signing Time',
  '1.2.840.113549.1.9.6': 'Countersignature',
  '1.2.840.113549.1.9.7': 'Challenge Password',
  '1.2.840.113549.1.9.8': 'Unstructured Address',
  '1.2.840.113549.1.9.9': 'Extended Certificate Attributes',
  '1.2.840.113549.1.9.10': 'Issuer And Serial Number',
  '1.2.840.113549.1.9.11': 'Password Check',
  '1.2.840.113549.1.9.12': 'Public Key',
  '1.2.840.113549.1.9.13': 'Signing Description',
  '1.2.840.113549.1.9.14': 'Extension Request',
  '1.2.840.113549.1.9.15': 'S/MIME Capabilities',
  '1.2.840.113549.1.9.15.1': 'Prefer Signed Data',
  '1.2.840.113549.1.9.15.2': 'Can Not Decrypt Any',
  '1.2.840.113549.1.9.15.3': 'Receipt Request',
  '1.2.840.113549.1.9.15.4': 'Receipt',
  '1.2.840.113549.1.9.15.5': 'Content Hints',
  '1.2.840.113549.1.9.15.6': 'Ml Expansion History',
  '1.2.840.113549.1.9.16': 'Id-sMIME',
  '1.2.840.113549.1.9.16.0': 'Id-mod',
  '1.2.840.113549.1.9.16.0.1': 'Id-mod-cms',
  '1.2.840.113549.1.9.16.0.2': 'Id-mod-ess',
  '1.2.840.113549.1.9.16.0.3': 'Id-mod-oid',
  '1.2.840.113549.1.9.16.0.4': 'Id-mod-msg-v3',
  '1.2.840.113549.1.9.16.0.5': 'Id-mod-ets-e Signature-88',
  '1.2.840.113549.1.9.16.0.6': 'Id-mod-ets-e Signature-97',
  '1.2.840.113549.1.9.16.0.7': 'Id-mod-ets-e Sig Policy-88',
  '1.2.840.113549.1.9.16.0.8': 'Id-mod-ets-e Sig Policy-88',
  '1.2.840.113549.1.9.16.1': 'Content Type',
  '1.2.840.113549.1.9.16.1.1': 'Receipt',
  '1.2.840.113549.1.9.16.1.2': 'Auth Data',
  '1.2.840.113549.1.9.16.1.3': 'Publish Cert',
  '1.2.840.113549.1.9.16.1.4': 'TST Info',
  '1.2.840.113549.1.9.16.1.5': 'TDT Info',
  '1.2.840.113549.1.9.16.1.6': 'Content Info',
  '1.2.840.113549.1.9.16.1.7': 'DVCS Request Data',
  '1.2.840.113549.1.9.16.1.8': 'DVCS Response Data',
  '1.2.840.113549.1.9.16.1.9': 'Compressed Data',
  '1.2.840.113549.1.9.16.1.10': 'SCVP Cert Val Request',
  '1.2.840.113549.1.9.16.1.11': 'SCVP Cert Val Response',
  '1.2.840.113549.1.9.16.1.12': 'SCVP Val Pol Request',
  '1.2.840.113549.1.9.16.1.13': 'SCVP Val Pol Response',
  '1.2.840.113549.1.9.16.1.14': 'Attr Cert Enc Attrs',
  '1.2.840.113549.1.9.16.1.15': 'TS Req',
  '1.2.840.113549.1.9.16.1.16': 'Firmware Package',
  '1.2.840.113549.1.9.16.1.17': 'Firmware Load Receipt',
  '1.2.840.113549.1.9.16.1.18': 'Firmware Load Error',
  '1.2.840.113549.1.9.16.1.19': 'Content Collection',
  '1.2.840.113549.1.9.16.1.20': 'Content with Attrs',
  '1.2.840.113549.1.9.16.1.21': 'Enc Key with I D',
  '1.2.840.113549.1.9.16.1.22': 'Enc PEPSI',
  '1.2.840.113549.1.9.16.1.23': 'Auth Enveloped Data',
  '1.2.840.113549.1.9.16.1.24': 'Route Origin Attest',
  '1.2.840.113549.1.9.16.1.25': 'Symmetric Key Package',
  '1.2.840.113549.1.9.16.1.26': 'Rpki Manifest',
  '1.2.840.113549.1.9.16.1.27': 'Ascii Text with CRLF',
  '1.2.840.113549.1.9.16.1.28': 'XML',
  '1.2.840.113549.1.9.16.1.29': 'PDF',
  '1.2.840.113549.1.9.16.1.30': 'Postscript',
  '1.2.840.113549.1.9.16.1.31': 'Timestamped Data',
  '1.2.840.113549.1.9.16.1.32': 'As Adjacency Attest',
  '1.2.840.113549.1.9.16.1.33': 'Rpki Trust Anchor',
  '1.2.840.113549.1.9.16.1.34': 'Trust Anchor List',
  '1.2.840.113549.1.9.16.2': 'Authenticated Attributes',
  '1.2.840.113549.1.9.16.2.1': 'Receipt Request',
  '1.2.840.113549.1.9.16.2.2': 'Security Label',
  '1.2.840.113549.1.9.16.2.3': 'Ml Expand History',
  '1.2.840.113549.1.9.16.2.4': 'Content Hint',
  '1.2.840.113549.1.9.16.2.5': 'Msg Sig Digest',
  '1.2.840.113549.1.9.16.2.6': 'Encap Content Type',
  '1.2.840.113549.1.9.16.2.7': 'Content Identifier',
  '1.2.840.113549.1.9.16.2.8': 'Mac Value',
  '1.2.840.113549.1.9.16.2.9': 'Equivalent Labels',
  '1.2.840.113549.1.9.16.2.10': 'Content Reference',
  '1.2.840.113549.1.9.16.2.11': 'Encryp Key Pref',
  '1.2.840.113549.1.9.16.2.12': 'Signing Certificate',
  '1.2.840.113549.1.9.16.2.13': 'Smime Encrypt Certs',
  '1.2.840.113549.1.9.16.2.14': 'Time Stamp Token',
  '1.2.840.113549.1.9.16.2.15': 'Sig Policy Id',
  '1.2.840.113549.1.9.16.2.16': 'Commitment Type',
  '1.2.840.113549.1.9.16.2.17': 'Signer Location',
  '1.2.840.113549.1.9.16.2.18': 'Signer Attr',
  '1.2.840.113549.1.9.16.2.19': 'Other Sig Cert',
  '1.2.840.113549.1.9.16.2.20': 'Content Timestamp',
  '1.2.840.113549.1.9.16.2.21': 'Certificate Refs',
  '1.2.840.113549.1.9.16.2.22': 'Revocation Refs',
  '1.2.840.113549.1.9.16.2.23': 'Cert Values',
  '1.2.840.113549.1.9.16.2.24': 'Revocation Values',
  '1.2.840.113549.1.9.16.2.25': 'Esc Time Stamp',
  '1.2.840.113549.1.9.16.2.26': 'Cert CRL Timestamp',
  '1.2.840.113549.1.9.16.2.27': 'Archive Time Stamp',
  '1.2.840.113549.1.9.16.2.28': 'Signature Type',
  '1.2.840.113549.1.9.16.2.29': 'Dvcs Dvc',
  '1.2.840.113549.1.9.16.2.30': 'Cek Reference',
  '1.2.840.113549.1.9.16.2.31': 'Max CEK Decrypts',
  '1.2.840.113549.1.9.16.2.32': 'Kek Derivation Alg',
  '1.2.840.113549.1.9.16.2.33': 'Intended Recipients',
  '1.2.840.113549.1.9.16.2.34': 'Cmc Unsigned Data',
  '1.2.840.113549.1.9.16.2.35': 'Fw Package ID',
  '1.2.840.113549.1.9.16.2.36': 'Fw Target Hardware IDs',
  '1.2.840.113549.1.9.16.2.37': 'Fw Decrypt Key ID',
  '1.2.840.113549.1.9.16.2.38': 'Fw Impl Crypt Algs',
  '1.2.840.113549.1.9.16.2.39': 'Fw Wrapped Firmware Key',
  '1.2.840.113549.1.9.16.2.40': 'Fw Community Identifiers',
  '1.2.840.113549.1.9.16.2.41': 'Fw Pkg Message Digest',
  '1.2.840.113549.1.9.16.2.42': 'Fw Package Info',
  '1.2.840.113549.1.9.16.2.43': 'Fw Impl Compress Algs',
  '1.2.840.113549.1.9.16.2.44': 'Ets Attr Certificate Refs',
  '1.2.840.113549.1.9.16.2.45': 'Ets Attr Revocation Refs',
  '1.2.840.113549.1.9.16.2.46': 'Binary Signing Time',
  '1.2.840.113549.1.9.16.2.47': 'Signing Certificate V2',
  '1.2.840.113549.1.9.16.2.48': 'Ets Archive Time Stamp V2',
  '1.2.840.113549.1.9.16.2.49': 'Er Internal',
  '1.2.840.113549.1.9.16.2.50': 'Er External',
  '1.2.840.113549.1.9.16.2.51': 'Multiple Signatures',
  '1.2.840.113549.1.9.16.3.1': 'Es DHwith3 DES',
  '1.2.840.113549.1.9.16.3.2': 'Es DHwith RC2',
  '1.2.840.113549.1.9.16.3.3': '3des Wrap',
  '1.2.840.113549.1.9.16.3.4': 'Rc2 Wrap',
  '1.2.840.113549.1.9.16.3.5': 'Es DH',
  '1.2.840.113549.1.9.16.3.6': 'Cms3 DESwrap',
  '1.2.840.113549.1.9.16.3.7': 'Cms RC2wrap',
  '1.2.840.113549.1.9.16.3.8': 'Zlib',
  '1.2.840.113549.1.9.16.3.9': 'Pwri KEK',
  '1.2.840.113549.1.9.16.3.10': 'Ss DH',
  '1.2.840.113549.1.9.16.3.11': 'Hmac With3 DE Swrap',
  '1.2.840.113549.1.9.16.3.12': 'Hmac with AE Swrap',
  '1.2.840.113549.1.9.16.3.13': 'MD5 Xor Experiment',
  '1.2.840.113549.1.9.16.3.14': 'RSA KEM',
  '1.2.840.113549.1.9.16.3.15': 'Auth Enc128',
  '1.2.840.113549.1.9.16.3.16': 'Auth Enc256',
  '1.2.840.113549.1.9.16.4.1': 'Cert Dist-ldap',
  '1.2.840.113549.1.9.16.5.1': 'Sig Policy Qualifier-spuri x',
  '1.2.840.113549.1.9.16.5.2': 'Sig Policy Qualifier-sp User Notice',
  '1.2.840.113549.1.9.16.6.1': 'Proof Of Origin',
  '1.2.840.113549.1.9.16.6.2': 'Proof Of Receipt',
  '1.2.840.113549.1.9.16.6.3': 'Proof Of Delivery',
  '1.2.840.113549.1.9.16.6.4': 'Proof Of Sender',
  '1.2.840.113549.1.9.16.6.5': 'Proof Of Approval',
  '1.2.840.113549.1.9.16.6.6': 'Proof Of Creation',
  '1.2.840.113549.1.9.16.8.1': 'Gl Use KEK',
  '1.2.840.113549.1.9.16.8.2': 'Gl Delete',
  '1.2.840.113549.1.9.16.8.3': 'Gl Add Member',
  '1.2.840.113549.1.9.16.8.4': 'Gl Delete Member',
  '1.2.840.113549.1.9.16.8.5': 'Gl Rekey',
  '1.2.840.113549.1.9.16.8.6': 'Gl Add Owner',
  '1.2.840.113549.1.9.16.8.7': 'Gl Remove Owner',
  '1.2.840.113549.1.9.16.8.8': 'Glk Compromise',
  '1.2.840.113549.1.9.16.8.9': 'Glk Refresh',
  '1.2.840.113549.1.9.16.8.10': 'Gl Fail Info',
  '1.2.840.113549.1.9.16.8.11': 'Gla Query Request',
  '1.2.840.113549.1.9.16.8.12': 'Gla Query Response',
  '1.2.840.113549.1.9.16.8.13': 'Gl Provide Cert',
  '1.2.840.113549.1.9.16.8.14': 'Gl Update Cert',
  '1.2.840.113549.1.9.16.8.15': 'Gl Key',
  '1.2.840.113549.1.9.16.9': 'Signature Type Identifier',
  '1.2.840.113549.1.9.16.9.1': 'Originator Sig',
  '1.2.840.113549.1.9.16.9.2': 'Domain Sig',
  '1.2.840.113549.1.9.16.9.3': 'Additional Attributes Sig',
  '1.2.840.113549.1.9.16.9.4': 'Review Sig',
  '1.2.840.113549.1.9.16.11': 'Capabilities',
  '1.2.840.113549.1.9.16.11.1': 'Prefer Binary Inside',
  '1.2.840.113549.1.9.20': 'Friendly Name (for PKCS #12)',
  '1.2.840.113549.1.9.21': 'Local Key I D (for PKCS #12)',
  '1.2.840.113549.1.9.22': 'Cert Types (for PKCS #12)',
  '1.2.840.113549.1.9.22.1': 'x509 Certificate (for PKCS #12)',
  '1.2.840.113549.1.9.22.2': 'SDSI Certificate (for PKCS #12)',
  '1.2.840.113549.1.9.23': 'CRL Types (for PKCS #12)',
  '1.2.840.113549.1.9.23.1': 'x509 Crl (for PKCS #12)',
  '1.2.840.113549.1.9.24': 'PKCS9object Class',
  '1.2.840.113549.1.9.25': 'PKCS9attributes',
  '1.2.840.113549.1.9.25.1': 'PKCS15 Token',
  '1.2.840.113549.1.9.25.2': 'Encrypted Private Key Info',
  '1.2.840.113549.1.9.25.3': 'Random Nonce',
  '1.2.840.113549.1.9.25.4': 'Sequence Number',
  '1.2.840.113549.1.9.25.5': 'PKCS7 PDU',
  '1.2.840.113549.1.9.26': 'PKCS9syntax',
  '1.2.840.113549.1.9.27': 'PKCS9matching Rules',
  '1.2.840.113549.1.12': 'PKCS-12',
  '1.2.840.113549.1.12.1': 'PKCS-12- Pbe Ids#12 mode ID',
  '1.2.840.113549.1.12.1.1': 'PBE with SHA And128 Bit RC4',
  '1.2.840.113549.1.12.1.2': 'PBE with SHA And40 Bit RC4',
  '1.2.840.113549.1.12.1.3': 'PBE with SHA And3-Key Triple DES-CBC',
  '1.2.840.113549.1.12.1.4': 'PBE with SHA And2-Key Triple DES-CBC',
  '1.2.840.113549.1.12.1.5': 'PBE with SHA And128 Bit RC2-CBC',
  '1.2.840.113549.1.12.1.6': 'PBE with SHA And40 Bit RC2-CBC',
  '1.2.840.113549.1.12.2': 'PKCS-12-ESPVKID',
  '1.2.840.113549.1.12.2.1': 'PKCS-12-PKCS8 Key Shrouding(1284011354911235) instead',
  '1.2.840.113549.1.12.3': 'PKCS-12-Bag Ids',
  '1.2.840.113549.1.12.3.1': 'PKCS-12-key Bag Id',
  '1.2.840.113549.1.12.3.2': 'PKCS-12-cert And CRL Bag Id',
  '1.2.840.113549.1.12.3.3': 'PKCS-12-secret Bag Id',
  '1.2.840.113549.1.12.3.4': 'PKCS-12-safe Contents Id',
  '1.2.840.113549.1.12.3.5': 'PKCS-12-pkcs',
  '1.2.840.113549.1.12.4': 'PKCS-12-Cert Bag ID',
  '1.2.840.113549.1.12.4.1': 'PKCS-12-x509 Cert CRL Bag I Dformerly assigned as pkcs-12-x509 Cert CRL Bag',
  '1.2.840.113549.1.12.4.2': 'PKCS-12-SDSI Cert Bag I Dformerly assigned as pkcs-12-SDSI Cert Bag',
  '1.2.840.113549.1.12.5': 'PKCS-12-OID',
  '1.2.840.113549.1.12.5.1': 'PKCS-12-PBEI Dthe partially compatible (128401135491121) OIDs instead',
  '1.2.840.113549.1.12.5.1.1': 'PKCS-12-PBE with SHA1 And128 Bit RC4use (1284011354911211) instead',
  '1.2.840.113549.1.12.5.1.2': 'PKCS-12-PBE with SHA1 And40 Bit RC4use (1284011354911212) instead',
  '1.2.840.113549.1.12.5.1.3': 'PKCS-12-PBE with SHA1 And Triple DESCB Cuse the incompatible but similar (1284011354911213) or (1284011354911214) instead',
  '1.2.840.113549.1.12.5.1.4': 'PKCS-12-PBE with SHA1 And128 Bit RC2CB Cuse (1284011354911215) instead',
  '1.2.840.113549.1.12.5.1.5': 'PKCS-12-PBE with SHA1 And40 Bit RC2CB Cuse (1284011354911216) instead',
  '1.2.840.113549.1.12.5.1.6': 'PKCS-12-PBE with SHA1 And RC4use the incompatible but similar (1284011354911211) or (1284011354911212) instead',
  '1.2.840.113549.1.12.5.1.7': 'PKCS-12-PBE with SHA1 And RC2CB Cuse the incompatible but similar (1284011354911215) or (1284011354911216) instead',
  '1.2.840.113549.1.12.5.2': 'PKCS-12-Enveloping I Dthe conventional PKCS#1OIDs instead',
  '1.2.840.113549.1.12.5.2.1': 'PKCS-12-RSA Encryption With128 Bit RC4use the conventional PKCS#1OIDs instead',
  '1.2.840.113549.1.12.5.2.2': 'PKCS-12-RSA Encryption With40 Bit RC4use the conventional PKCS#1OIDs instead',
  '1.2.840.113549.1.12.5.2.3': 'PKCS-12-RSA Encryption with Triple DESuse the conventional PKCS#1OIDs instead',
  '1.2.840.113549.1.12.5.3': 'PKCS-12-Signature IDuse the conventional PKCS#1OIDs instead',
  '1.2.840.113549.1.12.5.3.1': 'PKCS-12-RSA Signature with SHA1 Digestuse the conventional PKCS#1OIDs instead',
  '1.2.840.113549.1.12.10': 'PKCS-12 Version1',
  '1.2.840.113549.1.12.10.1': 'PKCS-12 Bad Ids',
  '1.2.840.113549.1.12.10.1.1': 'PKCS-12-key Bag',
  '1.2.840.113549.1.12.10.1.2': 'PKCS-12-pkcs',
  '1.2.840.113549.1.12.10.1.3': 'PKCS-12-cert Bag',
  '1.2.840.113549.1.12.10.1.4': 'PKCS-12-crl Bag',
  '1.2.840.113549.1.12.10.1.5': 'PKCS-12-secret Bag',
  '1.2.840.113549.1.12.10.1.6': 'PKCS-12-safe Contents Bag',
  '1.2.840.113549.1.15.1': 'PKCS15modules',
  '1.2.840.113549.1.15.2': 'PKCS15attributes',
  '1.2.840.113549.1.15.3': 'PKCS15content Type',
  '1.2.840.113549.1.15.3.1': 'PKCS15content',
  '1.2.840.113549.2': 'Digest Algorithm',
  '1.2.840.113549.2.2': 'MD2',
  '1.2.840.113549.2.4': 'MD4',
  '1.2.840.113549.2.5': 'MD5',
  '1.2.840.113549.2.7': 'HMAC with SHA1',
  '1.2.840.113549.2.8': 'HMAC with SHA224',
  '1.2.840.113549.2.9': 'HMAC with SHA256',
  '1.2.840.113549.2.10': 'HMAC with SHA384',
  '1.2.840.113549.2.11': 'HMAC with SHA512',
  '1.2.840.113549.3': 'Encryption Algorithm',
  '1.2.840.113549.3.2': 'Rc2CBC',
  '1.2.840.113549.3.3': 'Rc2ECB',
  '1.2.840.113549.3.4': 'Rc4',
  '1.2.840.113549.3.5': 'Rc4 with MAC',
  '1.2.840.113549.3.6': 'Desx-CBC',
  '1.2.840.113549.3.7': 'Des-EDE3-CBC',
  '1.2.840.113549.3.8': 'Rc5CBC',
  '1.2.840.113549.3.9': 'Rc5-CBCPad',
  '1.2.840.113549.3.10': 'DesCDMF',
  '1.2.840.113556.1.2.241': 'Delivery Mechanism',
  '1.2.840.113556.1.2.281': 'Nt Security Descriptor',
  '1.2.840.113556.1.3.0': 'Site-Addressing',
  '1.2.840.113556.1.3.13': 'Class Schema',
  '1.2.840.113556.1.3.14': 'Attribute Schema',
  '1.2.840.113556.1.3.17': 'Mailbox- Agent',
  '1.2.840.113556.1.3.22': 'Mailbox',
  '1.2.840.113556.1.3.23': 'Container',
  '1.2.840.113556.1.3.46': 'Mail Recipient',
  '1.2.840.113556.1.4.145': 'Revision',
  '1.2.840.113556.1.4.1327': 'PKI Default Key Spec',
  '1.2.840.113556.1.4.1328': 'PKI Key Usage',
  '1.2.840.113556.1.4.1329': 'PKI Max Issuing Depth',
  '1.2.840.113556.1.4.1330': 'PKI Critical Extensions',
  '1.2.840.113556.1.4.1331': 'PKI Expiration Period',
  '1.2.840.113556.1.4.1332': 'PKI Overlap Period',
  '1.2.840.113556.1.4.1333': 'PKI Extended Key Usage',
  '1.2.840.113556.1.4.1334': 'PKI Default CSPs',
  '1.2.840.113556.1.4.1335': 'PKI Enrollment Access',
  '1.2.840.113556.1.4.1429': 'MsPKI-RA-Signature',
  '1.2.840.113556.1.4.1430': 'MsPKI-Enrollment-Flag',
  '1.2.840.113556.1.4.1431': 'MsPKI-Private-Key',
  '1.2.840.113556.1.4.1432': 'MsPKI-Certificate-Name',
  '1.2.840.113556.1.4.1433': 'MsPKI-Minimal-Key',
  '1.2.840.113556.1.4.1434': 'MsPKI-Template-Schema',
  '1.2.840.113556.1.4.1435': 'MsPKI-Template-Minor',
  '1.2.840.113556.1.4.1436': 'MsPKI-Cert-Template',
  '1.2.840.113556.1.4.1437': 'MsPKI-Supersede-Templates',
  '1.2.840.113556.1.4.1438': 'MsPKI-RA-Policies',
  '1.2.840.113556.1.4.1439': 'MsPKI-Certificate-Policy',
  '1.2.840.113556.1.4.1674': 'MsPKI-Certificate-Application',
  '1.2.840.113556.1.4.1675': 'MsPKI-R A- Application',
  '1.2.840.113556.4.3': 'Microsoft Excel',
  '1.2.840.113556.4.4': 'Titled with OID',
  '1.2.840.113556.4.5': 'Microsoft Power Point',
  '1.2.840.113583.1': 'Adobe Acrobat',
  '1.2.840.113583.1.1': 'Acrobat Security',
  '1.2.840.113583.1.1.1': 'PDF Password',
  '1.2.840.113583.1.1.2': 'PDF Default Signing Credential',
  '1.2.840.113583.1.1.3': 'PDF Default Encryption Credential',
  '1.2.840.113583.1.1.4': 'PDF Password Timeout',
  '1.2.840.113583.1.1.5': 'PDF Authentic Documents Trust',
  '1.2.840.113583.1.1.6': 'PDF Dynamic Content Trust',
  '1.2.840.113583.1.1.7': 'PDF Ubiquity Trust',
  '1.2.840.113583.1.1.8': 'PDF Revocation Info Archival',
  '1.2.840.113583.1.1.9': 'PDF x509 Extension',
  '1.2.840.113583.1.1.9.1': 'Adobe Time-stamp',
  '1.2.840.113583.1.1.9.2': 'Adobe Archive Rev Info',
  '1.2.840.113583.1.1.10': 'PDF PPLK Lite Credential',
  '1.2.840.113583.1.2.': 'Acrobat CPS',
  '1.2.840.113583.1.2.1': 'PDF Authentic Documents CPS',
  '1.2.840.113583.1.2.2': 'PDF Test CPS',
  '1.2.840.113583.1.2.3': 'PDF Ubiquity CPS',
  '1.2.840.113583.1.2.4': 'PDF Adhoc CPS',
  '1.2.840.113583.1.7': 'Acrobat Ubiquity',
  '1.2.840.113583.1.7.1': 'PDF Ubiquity Sub Rights',
  '1.2.840.113583.1.9': 'Acrobat Extension',
  '1.2.840.113628.114.1.7': 'Adobe PKCS7',
  '1.2.840.113635.100': 'Apple Data Security',
  '1.2.840.113635.100.1': 'Apple Trust Policy',
  '1.2.840.113635.100.1.1': 'Apple I Sign TP',
  '1.2.840.113635.100.1.2': 'Apple x509 Basic',
  '1.2.840.113635.100.1.3': 'Apple SSL Policy',
  '1.2.840.113635.100.1.4': 'Apple Local Cert Gen Policy',
  '1.2.840.113635.100.1.5': 'Apple CSR Gen Policy',
  '1.2.840.113635.100.1.6': 'Apple CRL Policy',
  '1.2.840.113635.100.1.7': 'Apple OCSP Policy',
  '1.2.840.113635.100.1.8': 'Apple SMIME Policy',
  '1.2.840.113635.100.1.9': 'Apple EAP Policy',
  '1.2.840.113635.100.1.10': 'Apple SW Update Signing Policy',
  '1.2.840.113635.100.1.11': 'Apple IPSec Policy',
  '1.2.840.113635.100.1.12': 'Apple IChat Policy',
  '1.2.840.113635.100.1.13': 'Apple Resource Sign Policy',
  '1.2.840.113635.100.1.14': 'Apple PKINIT Client Policy',
  '1.2.840.113635.100.1.15': 'Apple PKINIT Server Policy',
  '1.2.840.113635.100.1.16': 'Apple Code Signing Policy',
  '1.2.840.113635.100.1.17': 'Apple Package Signing Policy',
  '1.2.840.113635.100.2': 'Apple Security Algorithm',
  '1.2.840.113635.100.2.1': 'Apple FEE',
  '1.2.840.113635.100.2.2': 'Apple ASC',
  '1.2.840.113635.100.2.3': 'Apple FEE_MD5',
  '1.2.840.113635.100.2.4': 'Apple FEE_SHA1',
  '1.2.840.113635.100.2.5': 'Apple FEED',
  '1.2.840.113635.100.2.6': 'Apple FEEDEXP',
  '1.2.840.113635.100.2.7': 'Apple ECDSA',
  '1.2.840.113635.100.3': 'Apple Dot Mac Certificate',
  '1.2.840.113635.100.3.1': 'Apple Dot Mac Certificate Request',
  '1.2.840.113635.100.3.2': 'Apple Dot Mac Certificate Extension',
  '1.2.840.113635.100.3.3': 'Apple Dot Mac Certificate Request Values',
  '1.2.840.113635.100.4': 'Apple Extended Key Usage',
  '1.2.840.113635.100.4.1': 'Apple Code Signing',
  '1.2.840.113635.100.4.1.1': 'Apple Code Signing Development',
  '1.2.840.113635.100.4.1.2': 'Apple Software Update Signing',
  '1.2.840.113635.100.4.1.3': 'Apple Code Signing Third Party',
  '1.2.840.113635.100.4.1.4': 'Apple Resource Signing',
  '1.2.840.113635.100.4.2': 'Apple I Chat Signing',
  '1.2.840.113635.100.4.3': 'Apple I Chat Encryption',
  '1.2.840.113635.100.4.4': 'Apple System Identity',
  '1.2.840.113635.100.4.5': 'Apple Crypto Env',
  '1.2.840.113635.100.4.5.1': 'Apple Crypto Production Env',
  '1.2.840.113635.100.4.5.2': 'Apple Crypto Maintenance Env',
  '1.2.840.113635.100.4.5.3': 'Apple Crypto Test Env',
  '1.2.840.113635.100.4.5.4': 'Apple Crypto Development Env',
  '1.2.840.113635.100.4.6': 'Apple Crypto Qo S',
  '1.2.840.113635.100.4.6.1': 'Apple Crypto Tier0 QoS',
  '1.2.840.113635.100.4.6.2': 'Apple Crypto Tier1 QoS',
  '1.2.840.113635.100.4.6.3': 'Apple Crypto Tier2 QoS',
  '1.2.840.113635.100.4.6.4': 'Apple Crypto Tier3 QoS',
  '1.2.840.113635.100.4.7': 'Apple ID Sharing Certificate',
  '1.2.840.113635.100.4.13': 'Apple Extended Key Usage Developer ID Installer',
  '1.2.840.113635.100.5': 'Apple Certificate Policies',
  '1.2.840.113635.100.5.1': 'Apple Certificate Policy ID',
  '1.2.840.113635.100.5.2': 'Apple Dot Mac Certificate Policy ID',
  '1.2.840.113635.100.5.3': 'Apple ADC Certificate Policy ID',
  '1.2.840.113635.100.5.7.1': 'Apple ID Sharing Certificate Policy',
  '1.2.840.113635.100.6': 'Apple Certificate Extensions',
  '1.2.840.113635.100.6.1': 'Apple Certificate Extension Code Signing',
  '1.2.840.113635.100.6.1.1': 'Apple Certificate Extension Apple Signing',
  '1.2.840.113635.100.6.1.2': 'Apple Certificate Extension ADC Developer Signing',
  '1.2.840.113635.100.6.1.3': 'Apple Certificate Extension ADC Apple Signing',
  '1.2.840.113635.100.6.2.3': 'Apple Application Integration',
  '1.2.840.113635.100.6.1.33': 'Apple Certificate Extension Developer ID Date',
  '1.2.840.113635.100.6.1.14': 'Apple Certificate Extension Developer ID Installer',
  '1.2.840.114021.1.6.1': 'Identrus unknown policy Identifier',
  '1.2.840.114021.4.1': 'Identrus OCSP',
  '1.3.6.1.4.1.188.7.1.1': 'Ascom',
  '1.3.6.1.4.1.188.7.1.1.1': 'Idea ECB',
  '1.3.6.1.4.1.188.7.1.1.2': 'Idea CBC',
  '1.3.6.1.4.1.188.7.1.1.3': 'Idea CFB',
  '1.3.6.1.4.1.188.7.1.1.4': 'Idea OFB',
  '1.3.6.1.4.1.311.2.1.4': 'Spc Indirect Data Context',
  '1.3.6.1.4.1.311.2.1.10': 'Spc Agency Info',
  '1.3.6.1.4.1.311.2.1.11': 'Spc Statement Type',
  '1.3.6.1.4.1.311.2.1.12': 'Spc Sp Opus Info',
  '1.3.6.1.4.1.311.2.1.14': 'Cert Req Extensions',
  '1.3.6.1.4.1.311.2.1.15': 'Spc P E Image Data',
  '1.3.6.1.4.1.311.2.1.18': 'Spc Raw File Data',
  '1.3.6.1.4.1.311.2.1.19': 'Spc Structured Storage Data',
  '1.3.6.1.4.1.311.2.1.20': 'Spc Java ClassData (type 1extension\',aka \'Glue extension)',
  '1.3.6.1.4.1.311.2.1.21': 'Individual Code Signing',
  '1.3.6.1.4.1.311.2.1.22': 'Commercial Code Signing',
  '1.3.6.1.4.1.311.2.1.25': 'Spc Link (type 2as \'Glue extension)',
  '1.3.6.1.4.1.311.2.1.26': 'Spc Minimal Criteria Info',
  '1.3.6.1.4.1.311.2.1.27': 'Spc Financial Criteria Info',
  '1.3.6.1.4.1.311.2.1.28': 'SpcLink (type 3as \'Glue extension)',
  '1.3.6.1.4.1.311.2.1.29': 'Spc Hash Info Obj ID',
  '1.3.6.1.4.1.311.2.1.30': 'Spc Sip Info Obj ID',
  '1.3.6.1.4.1.311.2.2': 'Ctl',
  '1.3.6.1.4.1.311.2.2.1': 'Ctl Trusted Codesigning CAList',
  '1.3.6.1.4.1.311.2.2.2': 'Ctl Trusted Client Auth CAList',
  '1.3.6.1.4.1.311.2.2.3': 'Ctl Trusted Server Auth CAList',
  '1.3.6.1.4.1.311.3.2.1': 'Timestamp Request',
  '1.3.6.1.4.1.311.10.1': 'Cert Trust List',
  '1.3.6.1.4.1.311.10.1.1': 'Sorted Ctl',
  '1.3.6.1.4.1.311.10.2': 'Next Update Location',
  '1.3.6.1.4.1.311.10.3.1': 'Cert Trust List Signing',
  '1.3.6.1.4.1.311.10.3.2': 'Time Stamp Signing',
  '1.3.6.1.4.1.311.10.3.3': 'Server Gated Crypto',
  '1.3.6.1.4.1.311.10.3.3.1': 'Serialized',
  '1.3.6.1.4.1.311.10.3.4': 'Encrypted File System',
  '1.3.6.1.4.1.311.10.3.4.1': 'Efs Recovery',
  '1.3.6.1.4.1.311.10.3.5': 'Whql Crypto',
  '1.3.6.1.4.1.311.10.3.6': 'Nt5 Crypto',
  '1.3.6.1.4.1.311.10.3.7': 'Oem WHQL Crypto',
  '1.3.6.1.4.1.311.10.3.8': 'Embedded NT Crypto',
  '1.3.6.1.4.1.311.10.3.9': 'Root List Signer',
  '1.3.6.1.4.1.311.10.3.10': 'Qualified Subordination',
  '1.3.6.1.4.1.311.10.3.11': 'Key Recovery',
  '1.3.6.1.4.1.311.10.3.12': 'Document Signing',
  '1.3.6.1.4.1.311.10.3.13': 'Lifetime Signing',
  '1.3.6.1.4.1.311.10.3.14': 'Mobile Device Software',
  '1.3.6.1.4.1.311.10.3.15': 'Smart Display',
  '1.3.6.1.4.1.311.10.3.16': 'Csp Signature',
  '1.3.6.1.4.1.311.10.4.1': 'yesno Trust Attr',
  '1.3.6.1.4.1.311.10.5.1': 'Drm',
  '1.3.6.1.4.1.311.10.5.2': 'Drm Individualization',
  '1.3.6.1.4.1.311.10.6.1': 'Licenses',
  '1.3.6.1.4.1.311.10.6.2': 'License Server',
  '1.3.6.1.4.1.311.10.7.1': 'Keyid Rdn',
  '1.3.6.1.4.1.311.10.8.1': 'Remove Certificate',
  '1.3.6.1.4.1.311.10.9.1': 'Cross Cert Dist Points',
  '1.3.6.1.4.1.311.10.10.1': 'Cmc Add Attributes',
  '1.3.6.1.4.1.311.10.11': 'Cert Prop Id Prefix',
  '1.3.6.1.4.1.311.10.11.4': 'Cert Md5 Hash Prop Id',
  '1.3.6.1.4.1.311.10.11.20': 'Cert Key Identifier Prop Id',
  '1.3.6.1.4.1.311.10.11.28': 'Cert Issuer Serial Number Md5 Hash Prop Id',
  '1.3.6.1.4.1.311.10.11.29': 'Cert Subject Name MD5 Hash Prop Id',
  '1.3.6.1.4.1.311.10.12.1': 'Any Application Policy',
  '1.3.6.1.4.1.311.12': 'Catalog',
  '1.3.6.1.4.1.311.12.1.1': 'Catalog List',
  '1.3.6.1.4.1.311.12.1.2': 'Catalog List Member',
  '1.3.6.1.4.1.311.12.2.1': 'Catalog Name Value Obj ID',
  '1.3.6.1.4.1.311.12.2.2': 'Catalog Member Info Obj ID',
  '1.3.6.1.4.1.311.13.1': 'Renewal Certificate',
  '1.3.6.1.4.1.311.13.2.1': 'Enrolment Name Value Pair',
  '1.3.6.1.4.1.311.13.2.2': 'Enrolment CSP',
  '1.3.6.1.4.1.311.13.2.3': 'Os Version',
  '1.3.6.1.4.1.311.16.4': 'Microsoft Recipient Info',
  '1.3.6.1.4.1.311.17.1': 'PKCS12 Key Provider Name Attr',
  '1.3.6.1.4.1.311.17.2': 'Local Machine Keyset',
  '1.3.6.1.4.1.311.17.3': 'PKCS12 Extended Attributes',
  '1.3.6.1.4.1.311.20.1': 'Auto Enroll Ctl Usage',
  '1.3.6.1.4.1.311.20.2': 'Microsoft Certificate Type',
  '1.3.6.1.4.1.311.20.2.1': 'Enrollment Agent',
  '1.3.6.1.4.1.311.20.2.2': 'Smartcard Logon',
  '1.3.6.1.4.1.311.20.2.3': 'NP Principal Name',
  '1.3.6.1.4.1.311.20.3': 'Cert Manifold',
  '1.3.6.1.4.1.311.21.1': 'Microsoft Certification Authority Renewal',
  '1.3.6.1.4.1.311.21.2': 'Microsoft Certificate Previous Hash',
  '1.3.6.1.4.1.311.21.3': 'CRL Virtual Base',
  '1.3.6.1.4.1.311.21.4': 'CRL Next Publish',
  '1.3.6.1.4.1.311.21.5': 'Ca Exchange',
  '1.3.6.1.4.1.311.21.6': 'Key Recovery',
  '1.3.6.1.4.1.311.21.7': 'Microsoft Certificate Template',
  '1.3.6.1.4.1.311.21.8': 'Enterprize OID Root',
  '1.3.6.1.4.1.311.21.9': 'Rdn Dummy Signer',
  '1.3.6.1.4.1.311.21.10': 'Microsoft Certificate Policies',
  '1.3.6.1.4.1.311.21.11': 'Application Policy Mappings',
  '1.3.6.1.4.1.311.21.12': 'Application Policy Constraints',
  '1.3.6.1.4.1.311.21.13': 'Archived Key',
  '1.3.6.1.4.1.311.21.14': 'CRL Self CDP',
  '1.3.6.1.4.1.311.21.15': 'Require Cert Chain Policy',
  '1.3.6.1.4.1.311.21.16': 'Archived Key Cert Hash',
  '1.3.6.1.4.1.311.21.17': 'Issued Cert Hash',
  '1.3.6.1.4.1.311.21.19': 'DS Email Replication',
  '1.3.6.1.4.1.311.21.20': 'Request Client Info',
  '1.3.6.1.4.1.311.21.21': 'Encrypted Key Hash',
  '1.3.6.1.4.1.311.21.22': 'Certsrv Cross CA Version',
  '1.3.6.1.4.1.311.25.1': 'Ntds Replication',
  '1.3.6.1.4.1.311.31.1': 'Product Update',
  '1.3.6.1.4.1.311.47.1.1': 'System Health',
  '1.3.6.1.4.1.311.47.1.3': 'System Health Loophole',
  '1.3.6.1.4.1.311.60.1.1': 'Root Program Flags',
  '1.3.6.1.4.1.311.60.2.1.1': 'Jurisdiction Of Incorporation L',
  '1.3.6.1.4.1.311.60.2.1.2': 'Jurisdiction Of Incorporation SP',
  '1.3.6.1.4.1.311.60.2.1.3': 'Jurisdiction Of Incorporation C',
  '1.3.6.1.4.1.311.61.1.1': 'Kernel Mode Code Signing',
  '1.3.6.1.4.1.311.84.1.1': 'ASP.NET HTTPS Development certificate',
  '1.3.6.1.4.1.311.88': 'CAPICOM',
  '1.3.6.1.4.1.311.88.1': 'CAPICOM version',
  '1.3.6.1.4.1.311.88.2': 'CAPICOM attribute',
  '1.3.6.1.4.1.311.88.2.1': 'Document type attribute',
  '1.3.6.1.4.1.311.88.2.2': 'Document description attribute',
  '1.3.6.1.4.1.311.88.3': 'CAPICOM encrypted data message',
  '1.3.6.1.4.1.311.88.3.1': 'CAPICOM content of encrypted data',
  '1.3.6.1.4.1.782.1.2.1.8.1': 'Network Solutions EV policy',
  '1.3.6.1.4.1.2428.10.1.1': 'UNINETT policy Identifier',
  '1.3.6.1.4.1.2712.10': 'ICE-TEL policy Identifier',
  '1.3.6.1.4.1.2786.1.1.1': 'ICE-TEL Italian',
  '1.3.6.1.4.1.3029.1.1.1': 'Blowfish ECB',
  '1.3.6.1.4.1.3029.1.1.2': 'Blowfish CBC',
  '1.3.6.1.4.1.3029.1.1.3': 'Blowfish CFB',
  '1.3.6.1.4.1.3029.1.1.4': 'Blowfish OFB',
  '1.3.6.1.4.1.3029.1.2.1': 'Elgamal',
  '1.3.6.1.4.1.3029.1.2.1.1': 'Elgamal with SHA-1',
  '1.3.6.1.4.1.3029.1.2.1.2': 'Elgamal with RIPEMD-160',
  '1.3.6.1.4.1.3029.3.1.1': 'Cryptlib Presence Check',
  '1.3.6.1.4.1.3029.3.1.2': 'Pki Boot',
  '1.3.6.1.4.1.3029.3.1.4': 'CRL Ext Reason',
  '1.3.6.1.4.1.3029.3.1.5': 'Key Features',
  '1.3.6.1.4.1.3029.4.1': 'Cryptlib Content',
  '1.3.6.1.4.1.3029.4.1.1': 'Cryptlib Config Data',
  '1.3.6.1.4.1.3029.4.1.2': 'Cryptlib User Index',
  '1.3.6.1.4.1.3029.4.1.3': 'Cryptlib User Info',
  '1.3.6.1.4.1.3029.4.1.4': 'Rtcs Request',
  '1.3.6.1.4.1.3029.4.1.5': 'Rtcs Response',
  '1.3.6.1.4.1.3029.4.1.6': 'Rtcs Response Ext',
  '1.3.6.1.4.1.3029.42.11172.1': 'Mpeg-1',
  '1.3.6.1.4.1.3029.54.11940.54': 'TSA policy \'Anythingpolicy',
  '1.3.6.1.4.1.3029.88.89.90.90.89': 'XYZZY policy Identifier',
  '1.3.6.1.4.1.3401.8.1.1': 'Pgp Extension',
  '1.3.6.1.4.1.3576.7': 'Ecia Asc X12 Edi',
  '1.3.6.1.4.1.3576.7.1': 'Plain ED Imessage',
  '1.3.6.1.4.1.3576.7.2': 'Signed ED Imessage',
  '1.3.6.1.4.1.3576.7.5': 'Integrity ED Imessage',
  '1.3.6.1.4.1.3576.7.65': 'Ia Receipt Message',
  '1.3.6.1.4.1.3576.7.97': 'Ia Status Message',
  '1.3.6.1.4.1.3576.8': 'Ecia Edifact',
  '1.3.6.1.4.1.3576.9': 'Ecia Non Edi',
  // https://www.globalsign.com/en/repository/GlobalSign_CP_v5.3.pdf
  '1.3.6.1.4.1.4146': 'GlobalSign',
  '1.3.6.1.4.1.4146.1': 'GlobalSign Policy',
  '1.3.6.1.4.1.4146.1.1': 'GlobalSign EV policy',
  '1.3.6.1.4.1.4146.1.10': 'GlobalSign DV Policy',
  '1.3.6.1.4.1.4146.1.20': 'GlobalSign OV Policy',
  '1.3.6.1.4.1.4146.1.30': 'GlobalSign TSA Policy',
  '1.3.6.1.4.1.4146.1.40': 'GlobalSign Client Certificates Policy',
  '1.3.6.1.4.1.4146.1.40.10': 'GlobalSign Client Certificates Enterprise PKI Policy',
  '1.3.6.1.4.1.4146.1.50': 'GlobalSign Code Signing Certificates Policy',
  '1.3.6.1.4.1.4146.1.60': 'GlobalSign Root Sign Policy',
  '1.3.6.1.4.1.4146.1.70': 'GlobalSign Trusted Root Policy',
  '1.3.6.1.4.1.4146.1.80': 'GlobalSign EDI Client Policy',
  '1.3.6.1.4.1.4146.1.81': 'GlobalSign EDI Server Policy',
  '1.3.6.1.4.1.4146.1.90': 'GlobalSign TPM Root Policy',
  '1.3.6.1.4.1.4146.1.95': 'GlobalSign OCSP Policy',
  //
  // https://developers.yubico.com/PIV/Introduction/PIV_attestation.html
  '1.3.6.1.4.1.41482.3.3': 'YubiKey Firmware Version',
  '1.3.6.1.4.1.41482.3.7': 'YubiKey Serial Number',
  '1.3.6.1.4.1.41482.3.8': 'YubiKey PIN Touch Policy',
  '1.3.6.1.4.1.41482.3.9': 'YubiKey Formfactor',
  //
  '1.3.6.1.4.1.4788.2.202.1': 'D-TRUSTEV policy',
  '1.3.6.1.4.1.5309.1': 'Edel Web Policy',
  '1.3.6.1.4.1.5309.1.2': 'Edel Web Customer Policy',
  '1.3.6.1.4.1.5309.1.2.1': 'Edel Web Clepsydre Policy',
  '1.3.6.1.4.1.5309.1.2.2': 'Edel Web Experimental TSA Policy',
  '1.3.6.1.4.1.5309.1.2.3': 'Edel Web Open Evidence TSA Policy',
  '1.3.6.1.4.1.53087.1.3': 'Trademark Country Or Region Name',
  '1.3.6.1.4.1.53087.1.4': 'Trademark Registration Number',
  '1.3.6.1.4.1.53087.1.6': 'Word Mark',
  '1.3.6.1.4.1.5472': 'Timeproof',
  '1.3.6.1.4.1.5472.1': 'TSS',
  '1.3.6.1.4.1.5472.1.1': 'TSS80',
  '1.3.6.1.4.1.5472.1.2': 'TSS380',
  '1.3.6.1.4.1.5472.1.3': 'TSS400',
  '1.3.6.1.4.1.5770.0.3': 'Secondary Practices',
  '1.3.6.1.4.1.5770.0.4': 'Physician Identifiers',
  '1.3.6.1.4.1.6334.1.100.1': 'Cybertrust EV policy',
  '1.3.6.1.4.1.6449.1.2.1.3.1': 'Comodo Policy',
  '1.3.6.1.4.1.6449.1.2.1.5.1': 'Comodo EV policy',
  '1.3.6.1.4.1.6449.1.2.2.7': 'Comodo TLS DV',
  '1.3.6.1.4.1.6449.1.2.2.15': 'Wotrust Policy',
  '1.3.6.1.4.1.6449.1.3.5.2': 'Comodo Certified Delivery Service',
  '1.3.6.1.4.1.6449.2.1.1': 'Comodo Timestamping Policy',
  '1.3.6.1.4.1.7879.13.24.1': 'T-Tele Sec EV policy',
  '1.3.6.1.4.1.8024.0.2.100.1.2': 'QuoVadis EV policy',
  '1.3.6.1.4.1.8231.1': 'Rol Unico Nacional',
  '1.3.6.1.4.1.8301.3.5.1': 'alidity Model Chain',
  '1.3.6.1.4.1.8301.3.5.2': 'alidity Model Shell',
  '1.3.6.1.4.1.11129.2.4.2': 'Certificate Transparency',
  '1.3.6.1.4.1.11591': 'Gnu',
  '1.3.6.1.4.1.11591.1': 'Gnu Radius',
  '1.3.6.1.4.1.11591.3': 'Gnu Radar',
  '1.3.6.1.4.1.11591.12': 'Gnu Digest Algorithm',
  '1.3.6.1.4.1.11591.12.2': 'Tiger',
  '1.3.6.1.4.1.11591.13': 'Gnu Encryption Algorithm',
  '1.3.6.1.4.1.11591.13.2': 'Serpent',
  '1.3.6.1.4.1.11591.13.2.1': 'Serpent128_ECB',
  '1.3.6.1.4.1.11591.13.2.2': 'Serpent128_CBC',
  '1.3.6.1.4.1.11591.13.2.3': 'Serpent128_OFB',
  '1.3.6.1.4.1.11591.13.2.4': 'Serpent128_CFB',
  '1.3.6.1.4.1.11591.13.2.21': 'Serpent192_ECB',
  '1.3.6.1.4.1.11591.13.2.22': 'Serpent192_CBC',
  '1.3.6.1.4.1.11591.13.2.23': 'Serpent192_OFB',
  '1.3.6.1.4.1.11591.13.2.24': 'Serpent192_CFB',
  '1.3.6.1.4.1.11591.13.2.41': 'Serpent256_ECB',
  '1.3.6.1.4.1.11591.13.2.42': 'Serpent256_CBC',
  '1.3.6.1.4.1.11591.13.2.43': 'Serpent256_OFB',
  '1.3.6.1.4.1.11591.13.2.44': 'Serpent256_CFB',
  '1.3.6.1.4.1.14370.1.6': 'Geo Trust EV policy',
  '1.3.6.1.4.1.14777.6.1.1': 'Izenpe EV policy',
  '1.3.6.1.4.1.14777.6.1.2': 'Izenpe EV policy',
  '1.3.6.1.4.1.16334.509.1.1': 'Northrop Grumman ext Key Usage?',
  '1.3.6.1.4.1.16334.509.2.1': 'Ngc Class1',
  '1.3.6.1.4.1.16334.509.2.2': 'Ngc Class2',
  '1.3.6.1.4.1.16334.509.2.3': 'Ngc Class3',
  '1.3.6.1.4.1.17326.10.8.12.1.2': 'Camerfirma EV policy',
  '1.3.6.1.4.1.17326.10.14.2.1.2': 'Camerfirma EV policy',
  '1.3.6.1.4.1.22112.2.1': 'Private Key Possession Statement',
  '1.3.6.1.4.1.22234.2.5.2.3.1': 'Cert Plus EV policy',
  '1.3.6.1.4.1.23223.1.1.1': 'Start Com EV policy',
  '1.3.6.1.4.1.23629.1.4.2.1.1': 'Safenet Usage Limit',
  '1.3.6.1.4.1.23629.1.4.2.1.2': 'Safenet End Date',
  '1.3.6.1.4.1.23629.1.4.2.1.3': 'Safenet Start Date',
  '1.3.6.1.4.1.23629.1.4.2.1.4': 'Safenet Admin Cert',
  '1.3.6.1.4.1.23629.1.4.2.2.1': 'Safenet Key Digest',
  '1.3.6.1.4.1.34697.2.1': 'Affirm Trust EV policy',
  '1.3.6.1.4.1.34697.2.2': 'Affirm Trust EV policy',
  '1.3.6.1.4.1.34697.2.3': 'Affirm Trust EV policy',
  '1.3.6.1.4.1.34697.2.4': 'Affirm Trust EV policy',
  '1.3.6.1.4.1.40869.1.1.22.3': 'TWCAEV policy',
  '1.3.6.1.4.1.13177.10.1.2.2': 'Corporate certificates for Natural Person',
  '1.3.6.1.4.1.37476.9000.64.1': 'Smallstep CA Provisioner ID',
  '1.3.6.1.5.2.3.4': 'KP Client Authentication',
  '1.3.6.1.5.2.3.5': 'KCD Authentication',
  '1.3.6.1.5.5.7': 'PKIX',
  '1.3.6.1.5.5.7.0.12': 'Attribute Cert',
  '1.3.6.1.5.5.7.1': 'Private Extension',
  '1.3.6.1.5.5.7.1.1': 'Certificate Authority Information Access',
  '1.3.6.1.5.5.7.1.2': 'Biometric Info',
  '1.3.6.1.5.5.7.1.3': 'Qualified Certificate Statements',
  '1.3.6.1.5.5.7.1.4': 'Ac Audit Identity',
  '1.3.6.1.5.5.7.1.5': 'Ac Targeting',
  '1.3.6.1.5.5.7.1.6': 'Ac Aa Controls',
  '1.3.6.1.5.5.7.1.7': 'Ip Addr Blocks',
  '1.3.6.1.5.5.7.1.8': 'Autonomous Sys Ids',
  '1.3.6.1.5.5.7.1.9': 'Router Identifier',
  '1.3.6.1.5.5.7.1.10': 'Ac Proxying',
  '1.3.6.1.5.5.7.1.11': 'Subject Info Access',
  '1.3.6.1.5.5.7.1.12': 'Logo Type',
  '1.3.6.1.5.5.7.1.13': 'Wlan SSID',
  '1.3.6.1.5.5.7.1.26': 'Telephone Number Authorization List',
  '1.3.6.1.5.5.7.2': 'Policy Qualifier Ids',
  '1.3.6.1.5.5.7.2.1': 'Certificate Policy Statement',
  '1.3.6.1.5.5.7.2.2': 'User Notice',
  '1.3.6.1.5.5.7.2.3': 'Text Notice',
  '1.3.6.1.5.5.7.3': 'Key Purpose',
  '1.3.6.1.5.5.7.3.1': 'Server Authentication',
  '1.3.6.1.5.5.7.3.2': 'Client Authentication',
  '1.3.6.1.5.5.7.3.3': 'Code Signing',
  '1.3.6.1.5.5.7.3.4': 'Email Protection',
  '1.3.6.1.5.5.7.3.5': 'Ipsec End System',
  '1.3.6.1.5.5.7.3.6': 'Ipsec Tunnel',
  '1.3.6.1.5.5.7.3.7': 'Ipsec User',
  '1.3.6.1.5.5.7.3.8': 'Time Stamping',
  '1.3.6.1.5.5.7.3.9': 'OCSP Signing',
  '1.3.6.1.5.5.7.3.10': 'DVCS',
  '1.3.6.1.5.5.7.3.11': 'Sbgp Cert AA Server Auth',
  '1.3.6.1.5.5.7.3.13': 'Eap Over PPP',
  '1.3.6.1.5.5.7.3.14': 'Eap Over LAN',
  '1.3.6.1.5.5.7.3.21': 'Secure Shell Client',
  '1.3.6.1.5.5.7.3.31': 'Brand Indicator for Message Identification',
  '1.3.6.1.5.5.7.3.46': 'Document Signing',
  '1.3.6.1.5.5.7.4': 'Cmp Information Types',
  '1.3.6.1.5.5.7.4.1': 'Ca Prot Enc Cert',
  '1.3.6.1.5.5.7.4.2': 'Sign Key Pair Types',
  '1.3.6.1.5.5.7.4.3': 'Enc Key Pair Types',
  '1.3.6.1.5.5.7.4.4': 'Preferred Symm Alg',
  '1.3.6.1.5.5.7.4.5': 'CA Key Update Info',
  '1.3.6.1.5.5.7.4.6': 'Current CRL',
  '1.3.6.1.5.5.7.4.7': 'Unsupported OIDs',
  '1.3.6.1.5.5.7.4.10': 'Key Pair Param Req',
  '1.3.6.1.5.5.7.4.11': 'Key Pair Param Rep',
  '1.3.6.1.5.5.7.4.12': 'Rev Passphrase',
  '1.3.6.1.5.5.7.4.13': 'Implicit Confirm',
  '1.3.6.1.5.5.7.4.14': 'Confirm Wait Time',
  '1.3.6.1.5.5.7.4.15': 'Orig PKI Message',
  '1.3.6.1.5.5.7.4.16': 'Supp Lang Tags',
  '1.3.6.1.5.5.7.5': 'Crmf Registration',
  '1.3.6.1.5.5.7.5.1': 'Reg Ctrl',
  '1.3.6.1.5.5.7.5.1.1': 'Reg Token',
  '1.3.6.1.5.5.7.5.1.2': 'Authenticator',
  '1.3.6.1.5.5.7.5.1.3': 'Pki Publication Info',
  '1.3.6.1.5.5.7.5.1.4': 'Pki Archive Options',
  '1.3.6.1.5.5.7.5.1.5': 'Old Cert ID',
  '1.3.6.1.5.5.7.5.1.6': 'Protocol Encr Key',
  '1.3.6.1.5.5.7.5.1.7': 'Alt Cert Template',
  '1.3.6.1.5.5.7.5.1.8': 'Wtls Template',
  '1.3.6.1.5.5.7.5.2': 'Utf8 Pairs',
  '1.3.6.1.5.5.7.5.2.1': 'Utf8 Pairs',
  '1.3.6.1.5.5.7.5.2.2': 'Cert Req',
  '1.3.6.1.5.5.7.6': 'Algorithms',
  '1.3.6.1.5.5.7.6.1': 'Des40',
  '1.3.6.1.5.5.7.6.2': 'No Signature',
  '1.3.6.1.5.5.7.6.3': 'Dh-sig-hmac',
  '1.3.6.1.5.5.7.6.4': 'Dh-pop',
  '1.3.6.1.5.5.7.7': 'CMC Controls',
  '1.3.6.1.5.5.7.8': 'Other Names',
  '1.3.6.1.5.5.7.8.1': 'Personal Data',
  '1.3.6.1.5.5.7.8.2': 'User Group',
  '1.3.6.1.5.5.7.8.3': 'Permanent Identifier',
  '1.3.6.1.5.5.7.8.5': 'Xmpp Addr',
  '1.3.6.1.5.5.7.8.9': 'SMTP UTF8 Mailbox',
  '1.3.6.1.5.5.7.9': 'Personal Data',
  '1.3.6.1.5.5.7.9.1': 'Date Of Birth',
  '1.3.6.1.5.5.7.9.2': 'Place Of Birth',
  '1.3.6.1.5.5.7.9.3': 'Gender',
  '1.3.6.1.5.5.7.9.4': 'Country Of Citizenship',
  '1.3.6.1.5.5.7.9.5': 'Country Of Residence',
  '1.3.6.1.5.5.7.10': 'Attribute Certificate',
  '1.3.6.1.5.5.7.10.1': 'Authentication Info',
  '1.3.6.1.5.5.7.10.2': 'Access Identity',
  '1.3.6.1.5.5.7.10.3': 'Charging Identity',
  '1.3.6.1.5.5.7.10.4': 'Group',
  '1.3.6.1.5.5.7.10.5': 'Role',
  '1.3.6.1.5.5.7.10.6': 'Wlan SSID',
  '1.3.6.1.5.5.7.11': 'Personal Data',
  '1.3.6.1.5.5.7.11.1': 'PKIX QC Syntax V1',
  '1.3.6.1.5.5.7.11.2': 'PKIX QC Syntax V2',
  '1.3.6.1.5.5.7.14.2': 'Resource Certificate Policy',
  '1.3.6.1.5.5.7.20': 'Logo',
  '1.3.6.1.5.5.7.20.1': 'Logo Loyalty',
  '1.3.6.1.5.5.7.20.2': 'Logo Background',
  '1.3.6.1.5.5.7.48.1': 'OCSP',
  '1.3.6.1.5.5.7.48.1.1': 'OCSP Basic',
  '1.3.6.1.5.5.7.48.1.2': 'OCSP Nonce',
  '1.3.6.1.5.5.7.48.1.3': 'OCSP CRL',
  '1.3.6.1.5.5.7.48.1.4': 'OCSP Response',
  '1.3.6.1.5.5.7.48.1.5': 'OCSP No Check',
  '1.3.6.1.5.5.7.48.1.6': 'OCSP Archive Cutoff',
  '1.3.6.1.5.5.7.48.1.7': 'OCSP Service Locator',
  '1.3.6.1.5.5.7.48.2': 'CA Issuers',
  '1.3.6.1.5.5.7.48.3': 'Time Stamping',
  '1.3.6.1.5.5.7.48.4': 'DVCS',
  '1.3.6.1.5.5.7.48.5': 'CA Repository',
  '1.3.6.1.5.5.7.48.7': 'Signed Object Repository',
  '1.3.6.1.5.5.7.48.10': 'Rpki Manifest',
  '1.3.6.1.5.5.7.48.11': 'Signed Object',
  '1.3.6.1.5.5.8.1.1': 'HMAC MD5',
  '1.3.6.1.5.5.8.1.2': 'HMAC SHA',
  '1.3.6.1.5.5.8.1.3': 'HMAC Tiger',
  '1.3.6.1.5.5.8.2.2': 'IKE Intermediate',
  '1.3.12.2.1011.7.1': 'DEC Encryption Algorithm',
  '1.3.12.2.1011.7.1.2': 'DEC DEA',
  '1.3.12.2.1011.7.2': 'DEC Hash Algorithm',
  '1.3.12.2.1011.7.2.1': 'DECMD2',
  '1.3.12.2.1011.7.2.2': 'DECMD4',
  '1.3.12.2.1011.7.3': 'DEC Signature Algorithm',
  '1.3.12.2.1011.7.3.1': 'DEC MD2 with RSA',
  '1.3.12.2.1011.7.3.2': 'DEC MD4 with RSA',
  '1.3.12.2.1011.7.3.3': 'DEC DEAMAC',
  '1.3.14.2.26.5': 'SHA',
  '1.3.14.3.2.1.1': 'RSA',
  '1.3.14.3.2.2': 'MD4 with RSA',
  '1.3.14.3.2.2.1': 'Sqmod-N',
  '1.3.14.3.2.3': 'MD5 with RSA',
  '1.3.14.3.2.3.1': 'Sqmod-Nwith RSA',
  '1.3.14.3.2.4': 'MD4 with RSA Encryption',
  '1.3.14.3.2.6': 'DES ECB',
  '1.3.14.3.2.7': 'DES CBC',
  '1.3.14.3.2.8': 'DES OFB',
  '1.3.14.3.2.9': 'DES CFB',
  '1.3.14.3.2.10': 'DES MAC',
  '1.3.14.3.2.11': 'RSA Signature',
  '1.3.14.3.2.12': 'DSA',
  '1.3.14.3.2.13': 'DSA with SHA',
  '1.3.14.3.2.14': 'MDC2 with RSA Signature',
  '1.3.14.3.2.15': 'SHA with RSA Signature',
  '1.3.14.3.2.16': 'DH with Common Modulus',
  '1.3.14.3.2.17': 'Des EDE',
  '1.3.14.3.2.18': 'SHA',
  '1.3.14.3.2.19': 'MDC-2',
  '1.3.14.3.2.20': 'DSA Common',
  '1.3.14.3.2.21': 'DSA Common with SHA',
  '1.3.14.3.2.22': 'RSA Key Transport',
  '1.3.14.3.2.23': 'Keyed-hash-seal',
  '1.3.14.3.2.24': 'MD2 with RSA Signature',
  '1.3.14.3.2.25': 'MD5 with RSA Signature',
  '1.3.14.3.2.26': 'SHA1',
  '1.3.14.3.2.27': 'DSA with SHA1',
  '1.3.14.3.2.28': 'DSA with Common SHA1',
  '1.3.14.3.2.29': 'SHA-1 with RSA Encryption',
  '1.3.14.3.3.1': 'Simple-strong-auth',
  '1.3.14.7.2.1.1': 'El Gamal',
  '1.3.14.7.2.3.1': 'MD2 with RSA',
  '1.3.14.7.2.3.2': 'MD2 with El Gamal',
  '1.3.36.1': 'Document',
  '1.3.36.1.1': 'Final Version',
  '1.3.36.1.2': 'Draft',
  '1.3.36.2': 'Sio',
  '1.3.36.2.1': 'Sedu',
  '1.3.36.3': 'Algorithm',
  '1.3.36.3.1': 'Encryption Algorithm',
  '1.3.36.3.1.1': 'DES',
  '1.3.36.3.1.1.1': 'DES ECB_pad',
  '1.3.36.3.1.1.1.1': 'DES ECB_ISOpad',
  '1.3.36.3.1.1.2.1': 'DES CBC_pad',
  '1.3.36.3.1.1.2.1.1': 'DES CBC_ISOpad',
  '1.3.36.3.1.2': 'IDEA',
  '1.3.36.3.1.2.1': 'IDEA ECB',
  '1.3.36.3.1.2.1.1': 'IDEA ECB_pad',
  '1.3.36.3.1.2.1.1.1': 'IDEA ECB_ISOpad',
  '1.3.36.3.1.2.2': 'IDEA CBC',
  '1.3.36.3.1.2.2.1': 'IDEA CBC_pad',
  '1.3.36.3.1.2.2.1.1': 'IDEA CBC_ISOpad',
  '1.3.36.3.1.2.3': 'IDEA OFB',
  '1.3.36.3.1.2.4': 'IDEA CFB',
  '1.3.36.3.1.3': 'DES_3',
  '1.3.36.3.1.3.1.1': 'DES_3 ECB_pad',
  '1.3.36.3.1.3.1.1.1': 'DES_3 ECB_ISOpad',
  '1.3.36.3.1.3.2.1': 'DES_3 CBC_pad',
  '1.3.36.3.1.3.2.1.1': 'DES_3 CBC_ISOpad',
  '1.3.36.3.1.4': 'RSA Encryption',
  '1.3.36.3.1.4.512.17': 'RSA Encryption Withlmod512expe17',
  '1.3.36.3.1.5': 'BSI-1',
  '1.3.36.3.1.5.1': 'BSI_1 ECB_pad',
  '1.3.36.3.1.5.2': 'BSI_1 CBC_pad',
  '1.3.36.3.1.5.2.1': 'BSI_1 CBC_PEMpad',
  '1.3.36.3.2': 'Hash Algorithm',
  '1.3.36.3.2.1': 'Ripemd160',
  '1.3.36.3.2.2': 'Ripemd128',
  '1.3.36.3.2.3': 'Ripemd256',
  '1.3.36.3.2.4': 'Mdc2single Length',
  '1.3.36.3.2.5': 'Mdc2double Length',
  '1.3.36.3.3': 'Signature Algorithm',
  '1.3.36.3.3.1': 'RSA Signature',
  '1.3.36.3.3.1.1': 'RSA Signature WithSHA1',
  '1.3.36.3.3.1.1.1024.11': 'RSA Signature WithSHA1_l1024_l11',
  '1.3.36.3.3.1.2': 'RSA Signature Withripemd160',
  '1.3.36.3.3.1.2.1024.11': 'RSA Signature Withripemd160_l1024_l11',
  '1.3.36.3.3.1.3': 'RSA Signature Withrimpemd128',
  '1.3.36.3.3.1.4': 'RSA Signature Withrimpemd256',
  '1.3.36.3.3.2': 'Ecsie Sign',
  '1.3.36.3.3.2.1': 'Ecsie Sign WithSHA1',
  '1.3.36.3.3.2.2': 'Ecsie Sign Withripemd160',
  '1.3.36.3.3.2.3': 'Ecsie Sign Withmd2',
  '1.3.36.3.3.2.4': 'Ecsie Sign Withmd5',
  '1.3.36.3.3.2.8.1.1.1': 'Brainpool P160r1',
  '1.3.36.3.3.2.8.1.1.2': 'Brainpool P160t1',
  '1.3.36.3.3.2.8.1.1.3': 'Brainpool P192r1',
  '1.3.36.3.3.2.8.1.1.4': 'Brainpool P192t1',
  '1.3.36.3.3.2.8.1.1.5': 'Brainpool P224r1',
  '1.3.36.3.3.2.8.1.1.6': 'Brainpool P224t1',
  '1.3.36.3.3.2.8.1.1.7': 'Brainpool P256r1',
  '1.3.36.3.3.2.8.1.1.8': 'Brainpool P256t1',
  '1.3.36.3.3.2.8.1.1.9': 'Brainpool P320r1',
  '1.3.36.3.3.2.8.1.1.10': 'Brainpool P320t1',
  '1.3.36.3.3.2.8.1.1.11': 'Brainpool P384r1',
  '1.3.36.3.3.2.8.1.1.12': 'Brainpool P384t1',
  '1.3.36.3.3.2.8.1.1.13': 'Brainpool P512r1',
  '1.3.36.3.3.2.8.1.1.14': 'Brainpool P512t1',
  '1.3.36.3.4': 'Signature Scheme',
  '1.3.36.3.4.1': 'Sig S_ISO9796-1',
  '1.3.36.3.4.2': 'Sig S_ISO9796-2',
  '1.3.36.3.4.2.1': 'Sig S_ISO9796-2 with RED',
  '1.3.36.3.4.2.2': 'Sig S_ISO9796-2 with RSA',
  '1.3.36.3.4.2.3': 'Sig S_ISO9796-2 with RDN',
  '1.3.36.4': 'Attribute',
  '1.3.36.5': 'Policy',
  '1.3.36.6': 'Api',
  '1.3.36.6.1': 'Manufacturer-specific_api',
  '1.3.36.6.1.1': 'Utimaco-api',
  '1.3.36.6.2': 'Functionality-specific_api',
  '1.3.36.7': 'Keymgmnt',
  '1.3.36.7.1': 'Keyagree',
  '1.3.36.7.1.1': 'Bsi PKE',
  '1.3.36.7.2': 'Keytrans',
  '1.3.36.7.2.1': 'Enc ISO9796-2 Withrsa',
  '1.3.36.8.1.1': 'Teletrust Sig G Conform policy Identifier',
  '1.3.36.8.2.1': 'Directory Service',
  '1.3.36.8.3.1': 'Date Of Cert Gen',
  '1.3.36.8.3.2': 'Procuration',
  '1.3.36.8.3.3': 'Admission',
  '1.3.36.8.3.4': 'Monetary Limit',
  '1.3.36.8.3.5': 'Declaration Of Majority',
  '1.3.36.8.3.6': 'Integrated Circuit Card Serial Number',
  '1.3.36.8.3.7': 'PK Reference',
  '1.3.36.8.3.8': 'Restriction',
  '1.3.36.8.3.9': 'Retrieve If Allowed',
  '1.3.36.8.3.10': 'Requested Certificate',
  '1.3.36.8.3.11': 'Naming Authorities',
  '1.3.36.8.3.11.1': 'Recht Wirtschaft Steuern',
  '1.3.36.8.3.11.1.1': 'Rechtsanwaeltin',
  '1.3.36.8.3.11.1.2': 'Rechtsanwalt',
  '1.3.36.8.3.11.1.3': 'Rechts Beistand',
  '1.3.36.8.3.11.1.4': 'Steuer Beraterin',
  '1.3.36.8.3.11.1.5': 'Steuer Berater',
  '1.3.36.8.3.11.1.6': 'Steuer Bevollmaechtigte',
  '1.3.36.8.3.11.1.7': 'Steuer Bevollmaechtigter',
  '1.3.36.8.3.11.1.8': 'Notarin',
  '1.3.36.8.3.11.1.9': 'Notar',
  '1.3.36.8.3.11.1.10': 'Notar Vertreterin',
  '1.3.36.8.3.11.1.11': 'Notar Vertreter',
  '1.3.36.8.3.11.1.12': 'Notariats Verwalterin',
  '1.3.36.8.3.11.1.13': 'Notariats Verwalter',
  '1.3.36.8.3.11.1.14': 'Wirtschafts Prueferin',
  '1.3.36.8.3.11.1.15': 'Wirtschafts Pruefer',
  '1.3.36.8.3.11.1.16': 'ereidigte Buchprueferin',
  '1.3.36.8.3.11.1.17': 'ereidigter Buchpruefer',
  '1.3.36.8.3.11.1.18': 'Patent Anwaeltin',
  '1.3.36.8.3.11.1.19': 'Patent Anwalt',
  '1.3.36.8.3.12': 'Cert In Dir Since',
  '1.3.36.8.3.13': 'Cert Hash',
  '1.3.36.8.3.14': 'Name At Birth',
  '1.3.36.8.3.15': 'Additional Information',
  '1.3.36.8.4.1': 'Personal Data',
  '1.3.36.8.4.8': 'Restriction',
  '1.3.36.8.5.1.1.1': 'RSA Indicate SHA1',
  '1.3.36.8.5.1.1.2': 'RSA Indicate RIPEMD160',
  '1.3.36.8.5.1.1.3': 'RSA with SHA1',
  '1.3.36.8.5.1.1.4': 'RSA with RIPEMD160',
  '1.3.36.8.5.1.2.1': 'Dsa Extended',
  '1.3.36.8.5.1.2.2': 'Dsa with RIPEMD160',
  '1.3.36.8.6.1': 'Cert',
  '1.3.36.8.6.2': 'Cert Ref',
  '1.3.36.8.6.3': 'Attr Cert',
  '1.3.36.8.6.4': 'Attr Ref',
  '1.3.36.8.6.5': 'File Name',
  '1.3.36.8.6.6': 'Storage Time',
  '1.3.36.8.6.7': 'File Size',
  '1.3.36.8.6.8': 'Location',
  '1.3.36.8.6.9': 'Sig Number',
  '1.3.36.8.6.10': 'Auto Gen',
  '1.3.36.8.7.1.1': 'Pt Adobe ILL',
  '1.3.36.8.7.1.2': 'Pt Ami Pro',
  '1.3.36.8.7.1.3': 'Pt Auto CAD',
  '1.3.36.8.7.1.4': 'Pt Binary',
  '1.3.36.8.7.1.5': 'Pt BMP',
  '1.3.36.8.7.1.6': 'Pt CGM',
  '1.3.36.8.7.1.7': 'Pt Corel CRT',
  '1.3.36.8.7.1.8': 'Pt Corel DRW',
  '1.3.36.8.7.1.9': 'Pt Corel EXC',
  '1.3.36.8.7.1.10': 'Pt Corel PHT',
  '1.3.36.8.7.1.11': 'Pt Draw',
  '1.3.36.8.7.1.12': 'Pt DVI',
  '1.3.36.8.7.1.13': 'Pt EPS',
  '1.3.36.8.7.1.14': 'Pt Excel',
  '1.3.36.8.7.1.15': 'Pt GEM',
  '1.3.36.8.7.1.16': 'Pt GIF',
  '1.3.36.8.7.1.17': 'Pt HPGL',
  '1.3.36.8.7.1.18': 'Pt JPEG',
  '1.3.36.8.7.1.19': 'Pt Kodak',
  '1.3.36.8.7.1.20': 'Pt LaTeX',
  '1.3.36.8.7.1.21': 'Pt Lotus',
  '1.3.36.8.7.1.22': 'Pt Lotus PIC',
  '1.3.36.8.7.1.23': 'Pt Mac PICT',
  '1.3.36.8.7.1.24': 'Pt Mac Word',
  '1.3.36.8.7.1.25': 'Pt MSWfD',
  '1.3.36.8.7.1.26': 'Pt MSWord',
  '1.3.36.8.7.1.27': 'Pt MSWord2',
  '1.3.36.8.7.1.28': 'Pt MSWord6',
  '1.3.36.8.7.1.29': 'Pt MSWord8',
  '1.3.36.8.7.1.30': 'Pt PDF',
  '1.3.36.8.7.1.31': 'Pt PIF',
  '1.3.36.8.7.1.32': 'Pt Postscript',
  '1.3.36.8.7.1.33': 'Pt RTF',
  '1.3.36.8.7.1.34': 'Pt SCITEX',
  '1.3.36.8.7.1.35': 'Pt TAR',
  '1.3.36.8.7.1.36': 'Pt Targa',
  '1.3.36.8.7.1.37': 'Pt TeX',
  '1.3.36.8.7.1.38': 'Pt Text',
  '1.3.36.8.7.1.39': 'Pt TIFF',
  '1.3.36.8.7.1.40': 'Pt TIFF-FC',
  '1.3.36.8.7.1.41': 'Pt UID',
  '1.3.36.8.7.1.42': 'Pt UU Encode',
  '1.3.36.8.7.1.43': 'Pt WMF',
  '1.3.36.8.7.1.44': 'Pt Word Perfect',
  '1.3.36.8.7.1.45': 'Pt WP Grph',
  '1.3.101.1.4': 'Thawte-ce',
  '1.3.101.1.4.1': 'Strong Extranet',
  '1.3.101.112': 'Edwards-curve Digital Signature Algorithm (EdDSA) Ed25519',
  '1.3.132.0.1': 'Sect163k1',
  '1.3.132.0.2': 'Sect163r1',
  '1.3.132.0.3': 'Sect239k1',
  '1.3.132.0.4': 'Sect113r1',
  '1.3.132.0.5': 'Sect113r2',
  '1.3.132.0.6': 'Secp112r1',
  '1.3.132.0.7': 'Secp112r2',
  '1.3.132.0.8': 'Secp160r1',
  '1.3.132.0.9': 'Secp160k1',
  '1.3.132.0.10': 'Secp256k1',
  '1.3.132.0.15': 'Sect163r2',
  '1.3.132.0.16': 'Sect283k1',
  '1.3.132.0.17': 'Sect283r1',
  '1.3.132.0.22': 'Sect131r1',
  '1.3.132.0.23': 'Sect131r2',
  '1.3.132.0.24': 'Sect193r1',
  '1.3.132.0.25': 'Sect193r2',
  '1.3.132.0.26': 'Sect233k1',
  '1.3.132.0.27': 'Sect233r1',
  '1.3.132.0.28': 'Secp128r1',
  '1.3.132.0.29': 'Secp128r2',
  '1.3.132.0.30': 'Secp160r2',
  '1.3.132.0.31': 'Secp192k1',
  '1.3.132.0.32': 'Secp224k1',
  '1.3.132.0.33': 'Secp224r1',
  '1.3.132.0.34': 'Secp384r1',
  '1.3.132.0.35': 'Secp521r1',
  '1.3.132.0.36': 'Sect409k1',
  '1.3.132.0.37': 'Sect409r1',
  '1.3.132.0.38': 'Sect571k1',
  '1.3.132.0.39': 'Sect571r1',
  '1.3.132.1.12': 'ECDH',
  '1.3.133.16.840.9.84': 'x984',
  '1.3.133.16.840.9.84.0': 'x984 Module',
  '1.3.133.16.840.9.84.0.1': 'x984 Biometrics',
  '1.3.133.16.840.9.84.0.2': 'x984 CMS',
  '1.3.133.16.840.9.84.0.3': 'x984 Identifiers',
  '1.3.133.16.840.9.84.1': 'x984 Biometric',
  '1.3.133.16.840.9.84.1.0': 'Biometric Unknown Type',
  '1.3.133.16.840.9.84.1.1': 'Biometric Body Odor',
  '1.3.133.16.840.9.84.1.2': 'Biometric DNA',
  '1.3.133.16.840.9.84.1.3': 'Biometric Ear Shape',
  '1.3.133.16.840.9.84.1.4': 'Biometric Facial Features',
  '1.3.133.16.840.9.84.1.5': 'Biometric Finger Image',
  '1.3.133.16.840.9.84.1.6': 'Biometric Finger Geometry',
  '1.3.133.16.840.9.84.1.7': 'Biometric Hand Geometry',
  '1.3.133.16.840.9.84.1.8': 'Biometric Iris Features',
  '1.3.133.16.840.9.84.1.9': 'Biometric Keystroke Dynamics',
  '1.3.133.16.840.9.84.1.10': 'Biometric Palm',
  '1.3.133.16.840.9.84.1.11': 'Biometric Retina',
  '1.3.133.16.840.9.84.1.12': 'Biometric Signature',
  '1.3.133.16.840.9.84.1.13': 'Biometric Speech Pattern',
  '1.3.133.16.840.9.84.1.14': 'Biometric Thermal Image',
  '1.3.133.16.840.9.84.1.15': 'Biometric Vein Pattern',
  '1.3.133.16.840.9.84.1.16': 'Biometric Thermal Face Image',
  '1.3.133.16.840.9.84.1.17': 'Biometric Thermal Hand Image',
  '1.3.133.16.840.9.84.1.18': 'Biometric Lip Movement',
  '1.3.133.16.840.9.84.1.19': 'Biometric Gait',
  '1.3.133.16.840.9.84.3': 'x984 Matching Method',
  '1.3.133.16.840.9.84.4': 'x984 Format Owner',
  '1.3.133.16.840.9.84.4.0': 'x984 Cbeff Owner',
  '1.3.133.16.840.9.84.4.1': 'x984 Ibia Owner',
  '1.3.133.16.840.9.84.4.1.1': 'Ibia Owner SAFLINK',
  '1.3.133.16.840.9.84.4.1.2': 'Ibia Owner Bioscrypt',
  '1.3.133.16.840.9.84.4.1.3': 'Ibia Owner Visionics',
  '1.3.133.16.840.9.84.4.1.4': 'Ibia Owner Infineon Technologies AG',
  '1.3.133.16.840.9.84.4.1.5': 'Ibia Owner Iridian Technologies',
  '1.3.133.16.840.9.84.4.1.6': 'Ibia Owner Veridicom',
  '1.3.133.16.840.9.84.4.1.7': 'Ibia Owner Cyber SIGN',
  '1.3.133.16.840.9.84.4.1.8': 'Ibia Ownere Cryp',
  '1.3.133.16.840.9.84.4.1.9': 'Ibia Owner Fingerprint Cards AB',
  '1.3.133.16.840.9.84.4.1.10': 'Ibia Owner Secu Gen',
  '1.3.133.16.840.9.84.4.1.11': 'Ibia Owner Precise Biometric',
  '1.3.133.16.840.9.84.4.1.12': 'Ibia Owner Identix',
  '1.3.133.16.840.9.84.4.1.13': 'Ibia Owner DERMALOG',
  '1.3.133.16.840.9.84.4.1.14': 'Ibia Owner LOGICO',
  '1.3.133.16.840.9.84.4.1.15': 'Ibia Owner NIST',
  '1.3.133.16.840.9.84.4.1.16': 'Ibia Owner A3 Vision',
  '1.3.133.16.840.9.84.4.1.17': 'Ibia Owner NEC',
  '1.3.133.16.840.9.84.4.1.18': 'Ibia Owner ST Microelectronics',
  '2.5.4.0': 'Object Class',
  '2.5.4.1': 'Aliased Entry Name',
  '2.5.4.2': 'Knowledge Information',
  '2.5.4.3': 'Common Name',
  '2.5.4.4': 'Surname',
  '2.5.4.5': 'Serial Number',
  '2.5.4.6': 'Country Name',
  '2.5.4.7': 'Locality',
  '2.5.4.7.1': 'Collective Locality Name',
  '2.5.4.8': 'State',
  '2.5.4.8.1': 'Collective State Or Province Name',
  '2.5.4.9': 'Street Address',
  '2.5.4.9.1': 'Collective Street Address',
  '2.5.4.97': 'Organization Identifier',
  '2.5.4.10': 'Organization',
  '2.5.4.10.1': 'Collective Organization Name',
  '2.5.4.11': 'Organization Unit',
  '2.5.4.11.1': 'Collective Organization Unit Name',
  '2.5.4.12': 'Title',
  '2.5.4.13': 'Description',
  '2.5.4.14': 'Search Guide',
  '2.5.4.15': 'Business Category',
  '2.5.4.16': 'Postal Address',
  '2.5.4.16.1': 'Collective Postal Address',
  '2.5.4.17': 'Postal Code',
  '2.5.4.17.1': 'Collective Postal Code',
  '2.5.4.18': 'Post Office Box',
  '2.5.4.18.1': 'Collective Post Office Box',
  '2.5.4.19': 'Physical Delivery Office Name',
  '2.5.4.19.1': 'Collective Physical Delivery Office Name',
  '2.5.4.20': 'Telephone Number',
  '2.5.4.20.1': 'Collective Telephone Number',
  '2.5.4.21': 'Telex Number',
  '2.5.4.21.1': 'Collective Telex Number',
  '2.5.4.22': 'Teletex Terminal Identifier',
  '2.5.4.22.1': 'Collective Teletex Terminal Identifier',
  '2.5.4.23': 'Facsimile Telephone Number',
  '2.5.4.23.1': 'Collective Facsimile Telephone Number',
  '2.5.4.24': 'x121 Address',
  '2.5.4.25': 'International ISDN Number',
  '2.5.4.25.1': 'Collective International ISDN Number',
  '2.5.4.26': 'Registered Address',
  '2.5.4.27': 'Destination Indicator',
  '2.5.4.28': 'Preferred Delivery Mehtod',
  '2.5.4.29': 'Presentation Address',
  '2.5.4.30': 'Supported Application Context',
  '2.5.4.31': 'Member',
  '2.5.4.32': 'Owner',
  '2.5.4.33': 'Role Occupant',
  '2.5.4.34': 'See Also',
  '2.5.4.35': 'User Password',
  '2.5.4.36': 'User Certificate',
  '2.5.4.37': 'Ca Certificate',
  '2.5.4.38': 'Authority Revocation List',
  '2.5.4.39': 'Certificate Revocation List',
  '2.5.4.40': 'Cross Certificate Pair',
  '2.5.4.41': 'Name',
  '2.5.4.42': 'Given Name',
  '2.5.4.43': 'Initials',
  '2.5.4.44': 'Generation Qualifier',
  '2.5.4.45': 'Unique Identifier',
  '2.5.4.46': 'Dn Qualifier',
  '2.5.4.47': 'Enhanced Search Guide',
  '2.5.4.48': 'Protocol Information',
  '2.5.4.49': 'Distinguished Name',
  '2.5.4.50': 'Unique Member',
  '2.5.4.51': 'House Identifier',
  '2.5.4.52': 'Supported Algorithms',
  '2.5.4.53': 'Delta Revocation List',
  '2.5.4.54': 'DMD Name',
  '2.5.4.55': 'Clearance',
  '2.5.4.56': 'Default Dir Qop',
  '2.5.4.57': 'Attribute Integrity Info',
  '2.5.4.58': 'Attribute Certificate',
  '2.5.4.59': 'Attribute Certificate Revocation List',
  '2.5.4.60': 'Conf Key Info',
  '2.5.4.61': 'AA Certificate',
  '2.5.4.62': 'Attribute Descriptor Certificate',
  '2.5.4.63': 'Attribute Authority Revocation List',
  '2.5.4.64': 'Family Information',
  '2.5.4.65': 'Pseudonym',
  '2.5.4.66': 'Communications Service',
  '2.5.4.67': 'Communications Network',
  '2.5.4.68': 'Certification Practice Stmt',
  '2.5.4.69': 'Certificate Policy',
  '2.5.4.70': 'Pki Path',
  '2.5.4.71': 'Priv Policy',
  '2.5.4.72': 'Role',
  '2.5.4.73': 'Delegation Path',
  '2.5.4.74': 'Prot Priv Policy',
  '2.5.4.75': 'XML Privilege Info',
  '2.5.4.76': 'XML Priv Policy',
  '2.5.4.82': 'Permission',
  '2.5.6.0': 'Top',
  '2.5.6.1': 'Alias',
  '2.5.6.2': 'Country',
  '2.5.6.3': 'Locality',
  '2.5.6.4': 'Organization',
  '2.5.6.5': 'Organization Unit',
  '2.5.6.6': 'Person',
  '2.5.6.7': 'Organization Person',
  '2.5.6.8': 'Organization Role',
  '2.5.6.9': 'Group Of Names',
  '2.5.6.10': 'Residential Person',
  '2.5.6.11': 'Application Process',
  '2.5.6.12': 'Application Entity',
  '2.5.6.13': 'DSA',
  '2.5.6.14': 'Device',
  '2.5.6.15': 'Strong Authentication User',
  '2.5.6.16': 'Certificate Authority',
  '2.5.6.17': 'Group Of Unique Names',
  '2.5.6.21': 'Pki User',
  '2.5.6.22': 'Pki CA',
  '2.5.8.1.1': 'RSA',
  '2.5.29.1': 'Authority Key Identifier',
  '2.5.29.2': 'Key Attributes',
  '2.5.29.3': 'Certificate Policies',
  '2.5.29.4': 'Key Usage Restriction',
  '2.5.29.5': 'Policy Mapping',
  '2.5.29.6': 'Subtrees Constraint',
  '2.5.29.7': 'Subject Alt Name',
  '2.5.29.8': 'Issuer Alt Name',
  '2.5.29.9': 'Subject Directory Attributes',
  '2.5.29.10': 'Basic Constraints',
  '2.5.29.11': 'Name Constraints',
  '2.5.29.12': 'Policy Constraints',
  '2.5.29.13': 'Basic Constraints',
  '2.5.29.14': 'Subject Key Identifier',
  '2.5.29.15': 'Key Usage',
  '2.5.29.16': 'Private Key Usage Period',
  '2.5.29.17': 'Subject Alternative Name',
  '2.5.29.18': 'Issuer Alternative Name',
  '2.5.29.19': 'Basic Constraints',
  '2.5.29.20': 'CRL Number',
  '2.5.29.21': 'CRL Reason',
  '2.5.29.22': 'Expiration Date',
  '2.5.29.23': 'Instruction Code',
  '2.5.29.24': 'Invalidity Date',
  '2.5.29.25': 'CRL Distribution Points',
  '2.5.29.26': 'Issuing Distribution Point',
  '2.5.29.27': 'Delta CRL Indicator',
  '2.5.29.28': 'Issuing Distribution Point',
  '2.5.29.29': 'Certificate Issuer',
  '2.5.29.30': 'Name Constraints',
  '2.5.29.31': 'CRL Distribution Points',
  '2.5.29.32': 'Certificate Policies',
  '2.5.29.32.0': 'Any Policy',
  '2.5.29.33': 'Policy Mappings',
  '2.5.29.34': 'Policy Constraints',
  '2.5.29.35': 'Authority Key Identifier',
  '2.5.29.36': 'Policy Constraints',
  '2.5.29.37': 'Extended Key Usage',
  '2.5.29.37.0': 'Any Extended Key Usage',
  '2.5.29.38': 'Authority Attribute Identifier',
  '2.5.29.39': 'Role Spec Cert Identifier',
  '2.5.29.40': 'CRL Stream Identifier',
  '2.5.29.41': 'Basic Att Constraints',
  '2.5.29.42': 'Delegated Name Constraints',
  '2.5.29.43': 'Time Specification',
  '2.5.29.44': 'CRL Scope',
  '2.5.29.45': 'Status Referrals',
  '2.5.29.46': 'Freshest CRL',
  '2.5.29.47': 'Ordered List',
  '2.5.29.48': 'Attribute Descriptor',
  '2.5.29.49': 'User Notice',
  '2.5.29.50': 'SOA Identifier',
  '2.5.29.51': 'Base Update Time',
  '2.5.29.52': 'Acceptable Cert Policies',
  '2.5.29.53': 'Delta Info',
  '2.5.29.54': 'Inhibit Any Policy',
  '2.5.29.55': 'Target Information',
  '2.5.29.56': 'No Rev Avail',
  '2.5.29.57': 'Acceptable Privilege Policies',
  '2.5.29.58': 'To Be Revoked',
  '2.5.29.59': 'Revoked Groups',
  '2.5.29.60': 'Expired Certs On CRL',
  '2.5.29.61': 'Indirect Issuer',
  '2.5.29.62': 'No Assertion',
  '2.5.29.63': 'A Aissuing Distribution Point',
  '2.5.29.64': 'Issued On Behalf Of',
  '2.5.29.65': 'Single Use',
  '2.5.29.66': 'Group AC',
  '2.5.29.67': 'Allowed Att Ass',
  '2.5.29.68': 'Attribute Mappings',
  '2.5.29.69': 'Holder Name Constraints',
  '2.16.528.1.1001.1.1.1.12.6.1.1.1': 'Digi Notar EV policy',
  '2.16.578.1.26.1.3.3': 'Buy Pass EV policy',
  '2.16.724.1.2.2.4.1': 'Personal Data Info',
  '2.16.756.1.89.1.2.1.1': 'Swiss Sign EV policy',
  '2.16.840.1.101.2.1.1.1': 'Sdns Signature Algorithm',
  '2.16.840.1.101.2.1.1.2': 'Fortezza Signature Algorithm',
  '2.16.840.1.101.2.1.1.3': 'Sdns Confidentiality Algorithm',
  '2.16.840.1.101.2.1.1.4': 'Fortezza Confidentiality Algorithm',
  '2.16.840.1.101.2.1.1.5': 'Sdns Integrity Algorithm',
  '2.16.840.1.101.2.1.1.6': 'Fortezza Integrity Algorithm',
  '2.16.840.1.101.2.1.1.7': 'Sdns Token Protection Algorithm',
  '2.16.840.1.101.2.1.1.8': 'Fortezza Token Protection Algorithm',
  '2.16.840.1.101.2.1.1.9': 'Sdns Key Management Algorithm',
  '2.16.840.1.101.2.1.1.10': 'Fortezza Key Management Algorithm',
  '2.16.840.1.101.2.1.1.11': 'Sdns K Mand Sig Algorithm',
  '2.16.840.1.101.2.1.1.12': 'Fortezza K Mand Sig Algorithm',
  '2.16.840.1.101.2.1.1.13': 'Suite A Signature Algorithm',
  '2.16.840.1.101.2.1.1.14': 'Suite A Confidentiality Algorithm',
  '2.16.840.1.101.2.1.1.15': 'Suite A Integrity Algorithm',
  '2.16.840.1.101.2.1.1.16': 'Suite A Token Protection Algorithm',
  '2.16.840.1.101.2.1.1.17': 'Suite A Key Management Algorithm',
  '2.16.840.1.101.2.1.1.18': 'Suite AK Mand Sig Algorithm',
  '2.16.840.1.101.2.1.1.19': 'Fortezza Updated Sig Algorithm',
  '2.16.840.1.101.2.1.1.20': 'Fortezza K Mand Upd Sig Algorithms',
  '2.16.840.1.101.2.1.1.21': 'Fortezza Updated Integ Algorithm',
  '2.16.840.1.101.2.1.1.22': 'Key Exchange Algorithm',
  '2.16.840.1.101.2.1.1.23': 'Fortezza Wrap80 Algorithm',
  '2.16.840.1.101.2.1.1.24': 'KEA Key Encryption Algorithm',
  '2.16.840.1.101.2.1.2.1': 'Rfc822 Message Format',
  '2.16.840.1.101.2.1.2.2': 'Empty Content',
  '2.16.840.1.101.2.1.2.3': 'Csp Content Type',
  '2.16.840.1.101.2.1.2.42': 'MSP Rev3 Content Type',
  '2.16.840.1.101.2.1.2.48': 'MSP Content Type',
  '2.16.840.1.101.2.1.2.49': 'MSP Rekey Agent Protocol',
  '2.16.840.1.101.2.1.2.50': 'MSP MMP',
  '2.16.840.1.101.2.1.2.66': 'MSP Rev3-1 Content Type',
  '2.16.840.1.101.2.1.2.72': 'Forwarded MSP Message Body Part',
  '2.16.840.1.101.2.1.2.73': 'MSP Forwarded Message Parameters',
  '2.16.840.1.101.2.1.2.74': 'Forwarded CSP Msg Body Part',
  '2.16.840.1.101.2.1.2.75': 'CSP Forwarded Message Parameters',
  '2.16.840.1.101.2.1.2.76': 'MSP MMP2',
  '2.16.840.1.101.2.1.3.1': 'SDNS Security Policy',
  '2.16.840.1.101.2.1.3.2': 'SDNS PRBAC',
  '2.16.840.1.101.2.1.3.3': 'Mosaic PRBAC',
  '2.16.840.1.101.2.1.3.10': 'SI Security Policy',
  '2.16.840.1.101.2.1.3.10.0': 'SI NASP',
  '2.16.840.1.101.2.1.3.10.1': 'SI ELCO',
  '2.16.840.1.101.2.1.3.10.2': 'SI TK',
  '2.16.840.1.101.2.1.3.10.3': 'SI DSAP',
  '2.16.840.1.101.2.1.3.10.4': 'SI SSSS',
  '2.16.840.1.101.2.1.3.10.5': 'SI DNASP',
  '2.16.840.1.101.2.1.3.10.6': 'SI BYEMAN',
  '2.16.840.1.101.2.1.3.10.7': 'SI REL-US',
  '2.16.840.1.101.2.1.3.10.8': 'SI REL-AUS',
  '2.16.840.1.101.2.1.3.10.9': 'SI REL-CAN',
  '2.16.840.1.101.2.1.3.10.10': 'SI REL_UK',
  '2.16.840.1.101.2.1.3.10.11': 'SI REL-NZ',
  '2.16.840.1.101.2.1.3.10.12': 'SI Generic',
  '2.16.840.1.101.2.1.3.11': 'Genser',
  '2.16.840.1.101.2.1.3.11.0': 'Genser Nations',
  '2.16.840.1.101.2.1.3.11.1': 'Genser Comsec',
  '2.16.840.1.101.2.1.3.11.2': 'Genser Acquisition',
  '2.16.840.1.101.2.1.3.11.3': 'Genser Security Categories',
  '2.16.840.1.101.2.1.3.11.3.0': 'Genser Tag Set Name',
  '2.16.840.1.101.2.1.3.12': 'Default Security Policy',
  '2.16.840.1.101.2.1.3.13': 'Capco Markings',
  '2.16.840.1.101.2.1.3.13.0': 'Capco Security Categories',
  '2.16.840.1.101.2.1.3.13.0.1': 'Capco Tag Set Name1',
  '2.16.840.1.101.2.1.3.13.0.2': 'Capco Tag Set Name2',
  '2.16.840.1.101.2.1.3.13.0.3': 'Capco Tag Set Name3',
  '2.16.840.1.101.2.1.3.13.0.4': 'Capco Tag Set Name4',
  '2.16.840.1.101.2.1.5.1': 'SDNS Key Management Certificate',
  '2.16.840.1.101.2.1.5.2': 'SDNS User Signature Certificate',
  '2.16.840.1.101.2.1.5.3': 'SDNS K Mand Sig Certificate',
  '2.16.840.1.101.2.1.5.4': 'Fortezza Key Management Certificate',
  '2.16.840.1.101.2.1.5.5': 'Fortezza K Mand Sig Certificate',
  '2.16.840.1.101.2.1.5.6': 'Fortezza User Signature Certificate',
  '2.16.840.1.101.2.1.5.7': 'Fortezza CA Signature Certificate',
  '2.16.840.1.101.2.1.5.8': 'SDNS CA Signature Certificate',
  '2.16.840.1.101.2.1.5.10': 'Auxiliary Vector',
  '2.16.840.1.101.2.1.5.11': 'Ml Receipt Policy',
  '2.16.840.1.101.2.1.5.12': 'Ml Membership',
  '2.16.840.1.101.2.1.5.13': 'Ml Administrators',
  '2.16.840.1.101.2.1.5.14': 'Alid',
  '2.16.840.1.101.2.1.5.20': 'Jan UKMs',
  '2.16.840.1.101.2.1.5.21': 'Feb UKMs',
  '2.16.840.1.101.2.1.5.22': 'Mar UKMs',
  '2.16.840.1.101.2.1.5.23': 'Apr UKMs',
  '2.16.840.1.101.2.1.5.24': 'May UKMs',
  '2.16.840.1.101.2.1.5.25': 'Jun UKMs',
  '2.16.840.1.101.2.1.5.26': 'Jul UKMs',
  '2.16.840.1.101.2.1.5.27': 'Aug UKMs',
  '2.16.840.1.101.2.1.5.28': 'Sep UKMs',
  '2.16.840.1.101.2.1.5.29': 'Oct UKMs',
  '2.16.840.1.101.2.1.5.30': 'Nov UKMs',
  '2.16.840.1.101.2.1.5.31': 'Dec UKMs',
  '2.16.840.1.101.2.1.5.40': 'Meta SDN Sckl',
  '2.16.840.1.101.2.1.5.41': 'Sdns CKL',
  '2.16.840.1.101.2.1.5.42': 'Meta SDN Ssignature CKL',
  '2.16.840.1.101.2.1.5.43': 'Sdns Signature CKL',
  '2.16.840.1.101.2.1.5.44': 'Sdns Certificate Revocation List',
  '2.16.840.1.101.2.1.5.45': 'Fortezza Certificate Revocation List',
  '2.16.840.1.101.2.1.5.46': 'Fortezza CKL',
  '2.16.840.1.101.2.1.5.47': 'Al Exempted Address Processor',
  '2.16.840.1.101.2.1.5.48': 'Guard',
  '2.16.840.1.101.2.1.5.49': 'Algorithms Supported',
  '2.16.840.1.101.2.1.5.50': 'Suite A Key Management Certificate',
  '2.16.840.1.101.2.1.5.51': 'Suite AK Mand Sig Certificate',
  '2.16.840.1.101.2.1.5.52': 'Suite A User Signature Certificate',
  '2.16.840.1.101.2.1.5.53': 'Prbac Info',
  '2.16.840.1.101.2.1.5.54': 'Prbac CA Constraints',
  '2.16.840.1.101.2.1.5.55': 'Sig Or KM Privileges',
  '2.16.840.1.101.2.1.5.56': 'Comm Privileges',
  '2.16.840.1.101.2.1.5.57': 'Labeled Attribute',
  '2.16.840.1.101.2.1.5.58': 'Policy Information File',
  '2.16.840.1.101.2.1.5.59': 'Sec Policy Information File',
  '2.16.840.1.101.2.1.5.60': 'CA Clearance Constraint',
  '2.16.840.1.101.2.1.7.1': 'CSP Extns',
  '2.16.840.1.101.2.1.7.1.0': 'CSP Cs Extn',
  '2.16.840.1.101.2.1.8.1': 'MISSI Security Categories',
  '2.16.840.1.101.2.1.8.2': 'Standard Security Label Privileges',
  '2.16.840.1.101.2.1.10.1': 'SIG Privileges',
  '2.16.840.1.101.2.1.10.2': 'KM Privileges',
  '2.16.840.1.101.2.1.10.3': 'Named Tag Set Privilege',
  '2.16.840.1.101.2.1.11.1': 'UK Demo',
  '2.16.840.1.101.2.1.11.2': 'US DOD Class2',
  '2.16.840.1.101.2.1.11.3': 'US Medium Pilot',
  '2.16.840.1.101.2.1.11.4': 'US DOD Class4',
  '2.16.840.1.101.2.1.11.5': 'US DOD Class3',
  '2.16.840.1.101.2.1.11.6': 'US DOD Class5',
  '2.16.840.1.101.2.1.12.0': 'Test Security Policy',
  '2.16.840.1.101.2.1.12.0.1': 'TSP1',
  '2.16.840.1.101.2.1.12.0.1.0': 'TSP1 Security Categories',
  '2.16.840.1.101.2.1.12.0.1.0.0': 'TSP1 Tag Set Zero',
  '2.16.840.1.101.2.1.12.0.1.0.1': 'TSP1 Tag Set One',
  '2.16.840.1.101.2.1.12.0.1.0.2': 'TSP1 Tag Set Two',
  '2.16.840.1.101.2.1.12.0.2': 'TSP2',
  '2.16.840.1.101.2.1.12.0.2.0': 'TSP2 Security Categories',
  '2.16.840.1.101.2.1.12.0.2.0.0': 'TSP2 Tag Set Zero',
  '2.16.840.1.101.2.1.12.0.2.0.1': 'TSP2 Tag Set One',
  '2.16.840.1.101.2.1.12.0.2.0.2': 'TSP2 Tag Set Two',
  '2.16.840.1.101.2.1.12.0.3': 'Kafka',
  '2.16.840.1.101.2.1.12.0.3.0': 'Kafka Security Categories',
  '2.16.840.1.101.2.1.12.0.3.0.1': 'Kafka Tag Set Name1',
  '2.16.840.1.101.2.1.12.0.3.0.2': 'Kafka Tag Set Name2',
  '2.16.840.1.101.2.1.12.0.3.0.3': 'Kafka Tag Set Name3',
  '2.16.840.1.101.2.1.12.1.1': 'TCp1',
  '2.16.840.1.101.3.1': 'Slabel',
  '2.16.840.1.101.3.2': 'PKI',
  '2.16.840.1.101.3.2.1': 'NIST policy Identifier',
  '2.16.840.1.101.3.2.1.2.7': 'USPTO Basic 2003',
  '2.16.840.1.101.3.2.1.2.8': 'USPTO Medium 2003',
  '2.16.840.1.101.3.2.1.2.9': 'USPTO Medium Hardware',
  '2.16.840.1.101.3.2.1.3.1': 'FBCA Rudimentary Policy',
  '2.16.840.1.101.3.2.1.3.2': 'FBCA Basic Policy',
  '2.16.840.1.101.3.2.1.3.3': 'FBCA Medium Policy',
  '2.16.840.1.101.3.2.1.3.4': 'FBCA High Policy',
  '2.16.840.1.101.3.2.1.3.12': 'FBCA Medium Hardware Policy',
  '2.16.840.1.101.3.2.1.3.13': 'FPKI Common Authentication Policy',
  '2.16.840.1.101.3.2.1.48.1': 'Nist Test Policy1',
  '2.16.840.1.101.3.2.1.48.2': 'Nist Test Policy2',
  '2.16.840.1.101.3.2.1.48.3': 'Nist Test Policy3',
  '2.16.840.1.101.3.2.1.48.4': 'Nist Test Policy4',
  '2.16.840.1.101.3.2.1.48.5': 'Nist Test Policy5',
  '2.16.840.1.101.3.2.1.48.6': 'Nist Test Policy6',
  '2.16.840.1.101.3.2.2': 'GAK',
  '2.16.840.1.101.3.2.2.1': 'KRA Key',
  '2.16.840.1.101.3.2.3': 'Extensions',
  '2.16.840.1.101.3.2.3.1': 'KR Technique',
  '2.16.840.1.101.3.2.3.2': 'K Recovery Capable',
  '2.16.840.1.101.3.2.3.3': 'KR',
  '2.16.840.1.101.3.2.4': 'Key Recovery Schemes',
  '2.16.840.1.101.3.2.5': 'Krapola',
  '2.16.840.1.101.3.3': 'ARPA',
  '2.16.840.1.101.3.4': 'Nist Algorithm',
  '2.16.840.1.101.3.4.1': 'AES',
  '2.16.840.1.101.3.4.1.1': 'AES128-ECB',
  '2.16.840.1.101.3.4.1.2': 'AES128-CBC',
  '2.16.840.1.101.3.4.1.3': 'AES128-OFB',
  '2.16.840.1.101.3.4.1.4': 'AES128-CFB',
  '2.16.840.1.101.3.4.1.5': 'AES128-wrap',
  '2.16.840.1.101.3.4.1.6': 'AES128-GCM',
  '2.16.840.1.101.3.4.1.7': 'AES128-CCM',
  '2.16.840.1.101.3.4.1.8': 'AES128-wrap-pad',
  '2.16.840.1.101.3.4.1.21': 'AES192-ECB',
  '2.16.840.1.101.3.4.1.22': 'AES192-CBC',
  '2.16.840.1.101.3.4.1.23': 'AES192-OFB',
  '2.16.840.1.101.3.4.1.24': 'AES192-CFB',
  '2.16.840.1.101.3.4.1.25': 'AES192-wrap',
  '2.16.840.1.101.3.4.1.26': 'AES192-GCM',
  '2.16.840.1.101.3.4.1.27': 'AES192-CCM',
  '2.16.840.1.101.3.4.1.28': 'AES192-wrap-pad',
  '2.16.840.1.101.3.4.1.41': 'AES256-ECB',
  '2.16.840.1.101.3.4.1.42': 'AES256-CBC',
  '2.16.840.1.101.3.4.1.43': 'AES256-OFB',
  '2.16.840.1.101.3.4.1.44': 'AES256-CFB',
  '2.16.840.1.101.3.4.1.45': 'AES256-wrap',
  '2.16.840.1.101.3.4.1.46': 'AES256-GCM',
  '2.16.840.1.101.3.4.1.47': 'AES256-CCM',
  '2.16.840.1.101.3.4.1.48': 'AES256-wrap-pad',
  '2.16.840.1.101.3.4.2': 'Hash Algos',
  '2.16.840.1.101.3.4.2.1': 'SHA-256',
  '2.16.840.1.101.3.4.2.2': 'SHA-384',
  '2.16.840.1.101.3.4.2.3': 'SHA-512',
  '2.16.840.1.101.3.4.2.4': 'SHA-224',
  '2.16.840.1.101.3.4.3.1': 'DSA with Sha224',
  '2.16.840.1.101.3.4.3.2': 'DSA with Sha256',
  '2.16.840.1.101.3.6.9.1': 'Personal Identity Verification (PIV) National Agency Check with Inquiries (NACI) indicator',
  '2.16.840.1.101.3.6.6': 'FASC-N',
  '2.16.840.1.113719.1.2.8': 'Novell Algorithm',
  '2.16.840.1.113719.1.2.8.22': 'DES Cbc IV8',
  '2.16.840.1.113719.1.2.8.23': 'DES Cbc Pad IV8',
  '2.16.840.1.113719.1.2.8.24': 'DES EDE2 Cbc IV8',
  '2.16.840.1.113719.1.2.8.25': 'DES EDE2 Cbc Pad IV8',
  '2.16.840.1.113719.1.2.8.26': 'DES EDE3 Cbc IV8',
  '2.16.840.1.113719.1.2.8.27': 'DES EDE3 Cbc Pad IV8',
  '2.16.840.1.113719.1.2.8.28': 'Rc5 Cbc Pad',
  '2.16.840.1.113719.1.2.8.29': 'MD2 with RSA Encryption B Safe1',
  '2.16.840.1.113719.1.2.8.30': 'MD5 with RSA Encryption B Safe1',
  '2.16.840.1.113719.1.2.8.31': 'SHA1 with RSA Encryption B Safe1',
  '2.16.840.1.113719.1.2.8.32': 'Lm Digest',
  '2.16.840.1.113719.1.2.8.40': 'MD2',
  '2.16.840.1.113719.1.2.8.50': 'MD5',
  '2.16.840.1.113719.1.2.8.51': 'Ike Hmac with SHA1-RSA',
  '2.16.840.1.113719.1.2.8.52': 'Ike Hmac with MD5-RSA',
  '2.16.840.1.113719.1.2.8.69': 'RC2 Cbc Pad',
  '2.16.840.1.113719.1.2.8.82': 'SHA-1',
  '2.16.840.1.113719.1.2.8.92': 'RC2 B Safe1 Cbc',
  '2.16.840.1.113719.1.2.8.95': 'MD4',
  '2.16.840.1.113719.1.2.8.130': 'MD4 Packet',
  '2.16.840.1.113719.1.2.8.131': 'RSA Encryption Bsafe1',
  '2.16.840.1.113719.1.2.8.132': 'Nw Password',
  '2.16.840.1.113719.1.2.8.133': 'Novell Obfuscate-1',
  '2.16.840.1.113719.1.9': 'PKI',
  '2.16.840.1.113719.1.9.4': 'PKI Attribute Type',
  '2.16.840.1.113719.1.9.4.1': 'Security Attributes',
  '2.16.840.1.113719.1.9.4.2': 'Reliance Limit',
  '2.16.840.1.113730.1': 'Certificate Extension',
  '2.16.840.1.113730.1.1': 'Netscape Certificate Type',
  '2.16.840.1.113730.1.2': 'Netscape Base Url',
  '2.16.840.1.113730.1.3': 'Netscape Revocation Url',
  '2.16.840.1.113730.1.4': 'Netscape CA Revocation',
  '2.16.840.1.113730.1.7': 'Netscape Certificate Renewal',
  '2.16.840.1.113730.1.8': 'Netscape CA Policy',
  '2.16.840.1.113730.1.9': 'Home Page Url',
  '2.16.840.1.113730.1.10': 'Entity Logo',
  '2.16.840.1.113730.1.11': 'User Picture',
  '2.16.840.1.113730.1.12': 'Netscape Ssl Server',
  '2.16.840.1.113730.1.13': 'Netscape Comment',
  '2.16.840.1.113730.2': 'Data-type',
  '2.16.840.1.113730.2.1': 'Data GIF',
  '2.16.840.1.113730.2.2': 'Data JPEG',
  '2.16.840.1.113730.2.3': 'Data URL',
  '2.16.840.1.113730.2.4': 'Data HTML',
  '2.16.840.1.113730.2.5': 'Cert Sequence',
  '2.16.840.1.113730.2.6': 'Cert URL',
  '2.16.840.1.113730.3': 'Directory',
  '2.16.840.1.113730.3.1': 'Ldap Definitions',
  '2.16.840.1.113730.3.1.1': 'Car License',
  '2.16.840.1.113730.3.1.2': 'Department Number',
  '2.16.840.1.113730.3.1.3': 'Employee Number',
  '2.16.840.1.113730.3.1.4': 'Employee Type',
  '2.16.840.1.113730.3.2.2': 'Inet Org Person',
  '2.16.840.1.113730.4.1': 'Server Gated Crypto',
  '2.16.840.1.113733.1': 'PKI',
  '2.16.840.1.113733.1.6.3': 'Verisign CZAG',
  '2.16.840.1.113733.1.6.6': 'Verisign In Box',
  '2.16.840.1.113733.1.6.11': 'Verisign Onsite Jurisdiction Hash',
  '2.16.840.1.113733.1.6.13': 'Unknown Verisign VPN extension',
  '2.16.840.1.113733.1.6.15': 'Verisign Server ID',
  '2.16.840.1.113733.1.7.1.1': 'Verisign Cert Policies95 Qualifier1',
  '2.16.840.1.113733.1.7.1.1.1': 'Verisign CP Sv1notice',
  '2.16.840.1.113733.1.7.1.1.2': 'Verisign CP Sv1nsi',
  '2.16.840.1.113733.1.7.54': 'Symantec',
  '2.16.840.1.113733.1.7.23.6': 'Veri Sign EV policy',
  '2.16.840.1.113733.1.7.48.1': 'Thawte EV policy',
  '2.16.840.1.113733.1.8.1': 'erisign ISS Strong Crypto',
  '2.16.840.1.113733.1.9': 'PKCS7 Attribute',
  '2.16.840.1.113733.1.9.2': 'Message Type',
  '2.16.840.1.113733.1.9.3': 'PKI Status',
  '2.16.840.1.113733.1.9.4': 'Fail Info',
  '2.16.840.1.113733.1.9.5': 'Sender Nonce',
  '2.16.840.1.113733.1.9.6': 'Recipient Nonce',
  '2.16.840.1.113733.1.9.7': 'Trans ID',
  '2.16.840.1.113733.1.9.8': 'Extension Req',
  '2.16.840.1.113741.2': 'Intel CDSA',
  '2.16.840.1.114028.10.1.2': 'Entrust EV policy',
  '2.16.840.1.114171.500.9': 'Wells Fargo EV policy',
  '2.16.840.1.114404.1.1.2.4.1': 'Trust Wave EV policy',
  '2.16.840.1.114412.1': 'Digi Cert Non EV Certs',
  '2.16.840.1.114412.1.1': 'Digi Cert OV Cert',
  '2.16.840.1.114412.1.2': 'Digi Cert DV Cert',
  '2.16.840.1.114412.1.3.0.1': 'Digi Cert Global CA Policy',
  '2.16.840.1.114412.1.3.0.2': 'Digi Cert High Assurance EVCA Policy',
  '2.16.840.1.114412.1.3.0.3': 'Digi Cert Global Root CA Policy',
  '2.16.840.1.114412.1.3.0.4': 'Digi Cert Assured ID Root CA Policy',
  '2.16.840.1.114412.1.11': 'Digi Cert Federated Device Cert',
  '2.16.840.1.114412.2.1': 'Digi Cert EV policy',
  '2.16.840.1.114412.2.2': 'Digi Cert EV Cert',
  '2.16.840.1.114412.2.3': 'Digi Cert Object Signing Cert',
  '2.16.840.1.114412.2.3.1': 'Digi Cert Code Signing Cert',
  '2.16.840.1.114412.2.3.2': 'Digi Cert EV Code Signing Cert',
  '2.16.840.1.114412.2.3.11': 'Digi Cert Kernel Code Signing Cert',
  '2.16.840.1.114412.2.3.21': 'Digi Cert Document Signing Cert',
  '2.16.840.1.114412.2.4': 'Digi Cert Client Cert',
  '2.16.840.1.114412.2.4.1.1': 'Digi Cert Level1 Personal Client Cert',
  '2.16.840.1.114412.2.4.1.2': 'Digi Cert Level1 Enterprise Client Cert',
  '2.16.840.1.114412.2.4.2': 'Digi Cert Level2 Client Cert',
  '2.16.840.1.114412.2.4.3.1': 'Digi Cert Level3 US Client Cert',
  '2.16.840.1.114412.2.4.3.2': 'Digi Cert Level3 CBP Client Cert',
  '2.16.840.1.114412.2.4.4.1': 'Digi Cert Level4 US Client Cert',
  '2.16.840.1.114412.2.4.4.2': 'Digi Cert Level4 CBP Client Cert',
  '2.16.840.1.114412.2.4.5.1': 'Digi Cert PIV Hardware Cert',
  '2.16.840.1.114412.2.4.5.2': 'Digi Cert PIV Card Auth Cert',
  '2.16.840.1.114412.2.4.5.3': 'Digi Cert PIV Content Signing Cert',
  '2.16.840.1.114412.4.31': 'Digi Cert Grid Classic Cert',
  '2.16.840.1.114412.4.31.5': 'Digi Cert Grid Integrated Cert',
  '2.16.840.1.114412.31.4.31.1': 'Digi Cert Grid Host Cert',
  '2.16.840.1.114413.1.7.23.3': 'Go Daddy EV policy',
  '2.16.840.1.114414.1.7.23.3': 'Starfield EV policy',
  '2.16.840.1.114569.1.1.3': 'SHAKEN/STIR Certificate Policy v1.3',
  '2.23.42.0': 'Content Type',
  '2.23.42.0.0': 'Pan Data',
  '2.23.42.0.1': 'Pan Token',
  '2.23.42.0.2': 'Pan Only',
  '2.23.42.1': 'Msg Ext',
  '2.23.42.2': 'Field',
  '2.23.42.2.0': 'Full Name',
  '2.23.42.2.1': 'Given Name',
  '2.23.42.2.2': 'Family Name',
  '2.23.42.2.3': 'Birth Family Name',
  '2.23.42.2.4': 'Place Name',
  '2.23.42.2.5': 'Identification Number',
  '2.23.42.2.6': 'Month',
  '2.23.42.2.7': 'Date',
  '2.23.42.2.8': 'Address',
  '2.23.42.2.9': 'Telephone',
  '2.23.42.2.10': 'Amount',
  '2.23.42.2.11': 'Account Number',
  '2.23.42.2.12': 'Pass Phrase',
  '2.23.42.3': 'Attribute',
  '2.23.42.3.0': 'Cert',
  '2.23.42.3.0.0': 'Root Key Thumb',
  '2.23.42.3.0.1': 'Additional Policy',
  '2.23.42.4': 'Algorithm',
  '2.23.42.5': 'Policy',
  '2.23.42.5.0': 'Root',
  '2.23.42.6': 'Module',
  '2.23.42.7': 'Cert Ext',
  '2.23.42.7.0': 'Hashed Root Key',
  '2.23.42.7.1': 'Certificate Type',
  '2.23.42.7.2': 'Merchant Data',
  '2.23.42.7.3': 'Card Cert Required',
  '2.23.42.7.4': 'Tunneling',
  '2.23.42.7.5': 'Set Extensions',
  '2.23.42.7.6': 'Set Qualifier',
  '2.23.42.8': 'Brand',
  '2.23.42.8.1': 'IATA-ATA',
  '2.23.42.8.4': ' ISA',
  '2.23.42.8.5': 'Master Card',
  '2.23.42.8.30': 'Diners',
  '2.23.42.8.34': 'American Express',
  '2.23.42.8.6011': 'Novus',
  '2.23.42.9': 'Vendor',
  '2.23.42.9.0': 'Globe Set',
  '2.23.42.9.1': 'IBM',
  '2.23.42.9.2': 'Cyber Cash',
  '2.23.42.9.3': 'Terisa',
  '2.23.42.9.4': 'RSADSI',
  '2.23.42.9.5': 'Veri Fone',
  '2.23.42.9.6': 'Trin Tech',
  '2.23.42.9.7': 'Bank Gate',
  '2.23.42.9.8': 'GTE',
  '2.23.42.9.9': 'Compu Source',
  '2.23.42.9.10': 'Griffin',
  '2.23.42.9.11': 'Certicom',
  '2.23.42.9.12': 'OSS',
  '2.23.42.9.13': 'Tenth Mountain',
  '2.23.42.9.14': 'Antares',
  '2.23.42.9.15': 'ECC',
  '2.23.42.9.16': 'Maithean',
  '2.23.42.9.17': 'Netscape',
  '2.23.42.9.18': 'erisign',
  '2.23.42.9.19': 'Blue Money',
  '2.23.42.9.20': 'Lacerte',
  '2.23.42.9.21': 'Fujitsu',
  '2.23.42.9.22': 'E Lab',
  '2.23.42.9.23': 'Entrust',
  '2.23.42.9.24': 'VI Anet',
  '2.23.42.9.25': 'III',
  '2.23.42.9.26': 'Open Market',
  '2.23.42.9.27': 'Lexem',
  '2.23.42.9.28': 'Intertrader',
  '2.23.42.9.29': 'Persimmon',
  '2.23.42.9.30': 'NABLE',
  '2.23.42.9.31': 'Espace-net',
  '2.23.42.9.32': 'Hitachi',
  '2.23.42.9.33': 'Microsoft',
  '2.23.42.9.34': 'NEC',
  '2.23.42.9.35': 'Mitsubishi',
  '2.23.42.9.36': 'NCR',
  '2.23.42.9.37': 'E-COMM',
  '2.23.42.9.38': 'Gemplus',
  '2.23.42.10': 'National',
  '2.23.42.10.392': 'Japan',
  '2.23.43.1.4': 'WTLS-ECC',
  '2.23.43.1.4.1': 'WTLS-ECC-curve1',
  '2.23.43.1.4.6': 'WTLS-ECC-curve6',
  '2.23.43.1.4.8': 'WTLS-ECC-curve8',
  '2.23.43.1.4.9': 'WTLS-ECC-curve9',
  '2.23.133': 'TCPA',
  '2.23.133.1': 'TCPA Spec Version',
  '2.23.133.2': 'TCPA Attribute',
  '2.23.133.2.1': 'TCPA Tpm Manufacturer',
  '2.23.133.2.2': 'TCPA Tpm Model',
  '2.23.133.2.3': 'TCPA Tpm Version',
  '2.23.133.2.4': 'TCPA Platform Manufacturer',
  '2.23.133.2.5': 'TCPA Platform Model',
  '2.23.133.2.6': 'TCPA Platform Version',
  '2.23.133.2.7': 'TCPA Component Manufacturer',
  '2.23.133.2.8': 'TCPA Component Model',
  '2.23.133.2.9': 'TCPA Component Version',
  '2.23.133.2.10': 'TCPA Security Qualities',
  '2.23.133.2.11': 'TCPA Tpm Protection Profile',
  '2.23.133.2.12': 'TCPA Tpm Security Target',
  '2.23.133.2.13': 'TCPA Foundation Protection Profile',
  '2.23.133.2.14': 'TCPA Foundation Security Target',
  '2.23.133.2.15': 'TCPA Tpm Id Label',
  '2.23.133.3': 'TCPA Protocol',
  '2.23.133.3.1': 'TCPA Prtt Tpm Id Protocol',
  '2.23.134.1.2.1.8.210': 'Post Signum Commercial Server Policy',
  '2.23.134.1.2.2.3': 'Post Signum Public CA',
  '2.23.134.1.4.2.1': 'Post Signum Root QCA',
  '2.23.136.1.1.1': 'MRTD Signature Data',
  '2.54.1775.2': 'Hashed Root Key',
  '2.54.1775.3': 'Certificate Type',
  '2.54.1775.4': 'Merchant Data',
  '2.54.1775.5': 'Card Cert Required',
  '2.54.1775.6': 'Tunneling',
  '2.54.1775.7': 'Set Qualifier',
  '2.54.1775.99': 'Set Data',
  '1.3.6.1.4.1.11129.2.4.3': 'CT Pre-Certificate Poison',
  '1.3.6.1.4.1.44947.1.1.1': 'Let\'s Encrypt',
  '1.3.6.1.4.1.4329.7.2.4': 'SSL TLS Certs',
  '1.3.6.1.4.1.4329.7': 'Siemens Public Key Infrastructure',
  '1.3.6.1.4.1.52266.1': 'Legal Entity Identifier',
  '1.3.6.1.4.1.52266.2': 'Role',
  '1.3.6.1.4.1.11129.2.1.17': 'Android Key Attestation',

  // https://ec.europa.eu/futurium/sites/futurium/files/ntqwac_pilot.pdf
  '0.4.0.9496.1': 'Domain Name Beneficiary',
  '0.4.0.9496.2': 'DNB Legal representative',
  '0.4.0.9496.3': 'Domain Name Owner',
  '0.4.0.9496.4': 'Domain Name Technical Operator',
  '0.4.0.9496.5': 'Type of relationship between DNB/DNO/DNT',
  '0.4.0.9496.6': 'DNB Main Activity Description',
  '0.4.0.9496.7': 'GDPR compliance attestation reference',
  '0.4.0.9496.8': 'Insurance coverage attestation',
  '0.4.0.9496.9': 'Valuation ranking',

  // https://cookie-daily.life/src/matter/matter_html/Chapter%206.%20Device%20Attestation%20and%20Operational%20Credentials.html
  '1.3.6.1.4.1.37244.2.1': 'Matter Vendor ID',
  '1.3.6.1.4.1.37244.2.2': 'Matter Product ID',

  // https://github.com/IETF-Hackathon/pqc-certificates/blob/master/docs/oid_mapping.md
  '1.3.6.1.4.1.18227.2.1': 'Composite With No Hash',
  '2.16.840.1.114027.80.4.1': 'Composite Key',
  '1.3.6.1.4.1.2.267.7.6.5': 'Dilithium3',
  '1.3.6.1.4.1.18227.999.1.2.1': 'Dilithium3 With SHA256',
  '1.3.6.1.4.1.18227.999.1.2.2': 'Dilithium3 With SHA384',
  '1.3.6.1.4.1.18227.999.1.2.3': 'Dilithium3 With SHA512',

  // https://cabforum.org/object-registry/
  '2.23.140.1.1': 'CA/B Forum Extended Validation',
  '2.23.140.1.2': 'CA/B Forum Baseline Requirements',
  '2.23.140.1.2.1': 'CA/B Forum Domain Validated',
  '2.23.140.1.2.2': 'CA/B Forum Organization Validated',
  '2.23.140.1.2.3': 'CA/B Forum Individual Validated',
  '2.23.140.1.3': 'CA/B Forum Extended Validation Codesigning',
  '2.23.140.1.4.1': 'CA/B Forum Codesigning Requirements Codesigning',
  '2.23.140.1.5': 'CA/B Forum S/MIME Baseline Requirements',
  '2.23.140.1.5.1.1': 'CA/B Forum Mailbox Validated Legacy',
  '2.23.140.1.5.1.2': 'CA/B Forum Mailbox Validated Multipurpose',
  '2.23.140.1.5.1.3': 'CA/B Forum Mailbox Validated Strict',
  '2.23.140.1.5.2.1': 'CA/B Forum Organization Validated Legacy',
  '2.23.140.1.5.2.2': 'CA/B Forum Organization Validated Multipurpose',
  '2.23.140.1.5.2.3': 'CA/B Forum Organization Validated Strict',
  '2.23.140.1.5.3.1': 'CA/B Forum Sponsor Validated Legacy',
  '2.23.140.1.5.3.2': 'CA/B Forum Sponsor Validated Multipurpose',
  '2.23.140.1.5.3.3': 'CA/B Forum Sponsor Validated Strict',
  '2.23.140.1.5.4.1': 'CA/B Forum Individual Validated Legacy',
  '2.23.140.1.5.4.2': 'CA/B Forum Individual Validated Multipurpose',
  '2.23.140.1.5.4.3': 'CA/B Forum Individual Validated Strict',
  '2.23.140.1.31': 'CA/B Forum Onion EV',
  '2.23.140.2.1': 'CA/B Forum Test Certificate',
  '2.23.140.3.1': 'CA/B Forum Organization Identifier',

  // https://github.com/IETF-Hackathon/pqc-certificates/blob/master/docs/oid_mapping.md
  '2.16.840.1.101.3.4.3.17': 'ML-DSA-44',
  '2.16.840.1.101.3.4.3.18': 'ML-DSA-65',
  '2.16.840.1.101.3.4.3.19': 'ML-DSA-87',
  '2.16.840.1.101.3.4.3.20': 'SLH-DSA-SHA2-128s',
  '2.16.840.1.101.3.4.3.21': 'SLH-DSA-SHA2-128f',
  '2.16.840.1.101.3.4.3.22': 'SLH-DSA-SHA2-192s',
  '2.16.840.1.101.3.4.3.23': 'SLH-DSA-SHA2-192f',
  '2.16.840.1.101.3.4.3.24': 'SLH-DSA-SHA2-256s',
  '2.16.840.1.101.3.4.3.25': 'SLH-DSA-SHA2-256f',
  '2.16.840.1.101.3.4.3.26': 'SLH-DSA-SHAKE-128s',
  '2.16.840.1.101.3.4.3.27': 'SLH-DSA-SHAKE-128f',
  '2.16.840.1.101.3.4.3.28': 'SLH-DSA-SHAKE-192f',
  '2.16.840.1.101.3.4.3.29': 'SLH-DSA-SHAKE-256s',
  '2.16.840.1.101.3.4.3.30': 'SLH-DSA-SHAKE-256f',
  '2.16.840.1.101.3.4.3.31': 'SLH-DSA-SHAKE-256f',
};
